/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MessagesRouteImport } from './routes/messages'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AccountingAuditLogRouteImport } from './routes/accounting/audit-log'
import { Route as AccountingReclassifyRouteImport } from './routes/accounting/reclassify'
import { Route as AccountingWriteOffInvoicesRouteImport } from './routes/accounting/write-off-invoices'
import { Route as AiAccountantIndexRouteImport } from './routes/ai-accountant/index'
import { Route as AiAccountantIdRouteImport } from './routes/ai-accountant/$id'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as BankingIndexRouteImport } from './routes/banking/index'
import { Route as BankingImportRouteImport } from './routes/banking/import'
import { Route as BankingRulesRouteImport } from './routes/banking/rules'
import { Route as DocumentsApprovalsRouteImport } from './routes/documents/approvals'
import { Route as DocumentsInboxRouteImport } from './routes/documents/inbox'
import { Route as ExpensesIndexRouteImport } from './routes/expenses/index'
import { Route as ExpensesPayBillsRouteImport } from './routes/expenses/pay-bills'
import { Route as HelpShortcutsRouteImport } from './routes/help/shortcuts'
import { Route as InventoryAdjustRouteImport } from './routes/inventory/adjust'
import { Route as PracticeClientsRouteImport } from './routes/practice/clients'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as ReportsIndexRouteImport } from './routes/reports/index'
import { Route as ReportsReportKeyRouteImport } from './routes/reports/$reportKey'
import { Route as ReportsVatDetailRouteImport } from './routes/reports/vat-detail'
import { Route as ReportsVatExceptionRouteImport } from './routes/reports/vat-exception'
import { Route as ReportsVatSummaryRouteImport } from './routes/reports/vat-summary'
import { Route as SalesIndexRouteImport } from './routes/sales/index'
import { Route as SalesAllRouteImport } from './routes/sales/all'
import { Route as SettingsAttachmentsRouteImport } from './routes/settings/attachments'
import { Route as SettingsClassesRouteImport } from './routes/settings/classes'
import { Route as SettingsCompanyRouteImport } from './routes/settings/company'
import { Route as SettingsCurrenciesRouteImport } from './routes/settings/currencies'
import { Route as SettingsExportRouteImport } from './routes/settings/export'
import { Route as SettingsLocationsRouteImport } from './routes/settings/locations'
import { Route as SettingsNotificationsRouteImport } from './routes/settings/notifications'
import { Route as SettingsProfileRouteImport } from './routes/settings/profile'
import { Route as SettingsSentEmailsRouteImport } from './routes/settings/sent-emails'
import { Route as SettingsTagsRouteImport } from './routes/settings/tags'
import { Route as SettingsUsersRouteImport } from './routes/settings/users'
import { Route as TaxesCorporateTaxRouteImport } from './routes/taxes/corporate-tax'
import { Route as TaxesEInvoicingRouteImport } from './routes/taxes/e-invoicing'
import { Route as AccountingBudgetsIndexRouteImport } from './routes/accounting/budgets/index'
import { Route as AccountingBudgetsBudgetIdRouteImport } from './routes/accounting/budgets/$budgetId'
import { Route as AccountingChartOfAccountsIndexRouteImport } from './routes/accounting/chart-of-accounts/index'
import { Route as AccountingFixedAssetsIndexRouteImport } from './routes/accounting/fixed-assets/index'
import { Route as AccountingFixedAssetsAssetIdRouteImport } from './routes/accounting/fixed-assets/$assetId'
import { Route as AccountingJournalEntriesIndexRouteImport } from './routes/accounting/journal-entries/index'
import { Route as AccountingJournalEntriesEntryIdRouteImport } from './routes/accounting/journal-entries/$entryId'
import { Route as AccountingJournalEntriesNewRouteImport } from './routes/accounting/journal-entries/new'
import { Route as AccountingPeriodsIndexRouteImport } from './routes/accounting/periods/index'
import { Route as AccountingRecurringIndexRouteImport } from './routes/accounting/recurring/index'
import { Route as AccountingRecurringTemplateIdRouteImport } from './routes/accounting/recurring/$templateId'
import { Route as AccountingRecurringNewRouteImport } from './routes/accounting/recurring/new'
import { Route as BankingReconcileIndexRouteImport } from './routes/banking/reconcile/index'
import { Route as BankingTransfersNewRouteImport } from './routes/banking/transfers/new'
import { Route as ExpensesBillsIndexRouteImport } from './routes/expenses/bills/index'
import { Route as ExpensesBillsDocumentIdRouteImport } from './routes/expenses/bills/$documentId'
import { Route as ExpensesBillsNewRouteImport } from './routes/expenses/bills/new'
import { Route as ExpensesDebitNotesDocumentIdRouteImport } from './routes/expenses/debit-notes/$documentId'
import { Route as ExpensesDebitNotesNewRouteImport } from './routes/expenses/debit-notes/new'
import { Route as ExpensesExpensesDocumentIdRouteImport } from './routes/expenses/expenses/$documentId'
import { Route as ExpensesExpensesNewRouteImport } from './routes/expenses/expenses/new'
import { Route as ExpensesPaymentsPaymentIdRouteImport } from './routes/expenses/payments/$paymentId'
import { Route as ExpensesPurchaseOrdersIndexRouteImport } from './routes/expenses/purchase-orders/index'
import { Route as ExpensesPurchaseOrdersDocumentIdRouteImport } from './routes/expenses/purchase-orders/$documentId'
import { Route as ExpensesPurchaseOrdersNewRouteImport } from './routes/expenses/purchase-orders/new'
import { Route as ExpensesVendorsIndexRouteImport } from './routes/expenses/vendors/index'
import { Route as ExpensesVendorsContactIdRouteImport } from './routes/expenses/vendors/$contactId'
import { Route as ReportsManagementPackIdRouteImport } from './routes/reports/management/$packId'
import { Route as ReportsManagementNewRouteImport } from './routes/reports/management/new'
import { Route as ReportsParallelRunIndexRouteImport } from './routes/reports/parallel-run/index'
import { Route as ReportsParallelRunRunIdRouteImport } from './routes/reports/parallel-run/$runId'
import { Route as SalesCreditNotesDocumentIdRouteImport } from './routes/sales/credit-notes/$documentId'
import { Route as SalesCreditNotesNewRouteImport } from './routes/sales/credit-notes/new'
import { Route as SalesCustomersIndexRouteImport } from './routes/sales/customers/index'
import { Route as SalesCustomersContactIdRouteImport } from './routes/sales/customers/$contactId'
import { Route as SalesDeliveryChallansIndexRouteImport } from './routes/sales/delivery-challans/index'
import { Route as SalesDeliveryChallansDocumentIdRouteImport } from './routes/sales/delivery-challans/$documentId'
import { Route as SalesDeliveryChallansNewRouteImport } from './routes/sales/delivery-challans/new'
import { Route as SalesInvoicesIndexRouteImport } from './routes/sales/invoices/index'
import { Route as SalesInvoicesDocumentIdRouteImport } from './routes/sales/invoices/$documentId'
import { Route as SalesInvoicesNewRouteImport } from './routes/sales/invoices/new'
import { Route as SalesPaymentsPaymentIdRouteImport } from './routes/sales/payments/$paymentId'
import { Route as SalesProductsAndServicesIndexRouteImport } from './routes/sales/products-and-services/index'
import { Route as SalesQuotesIndexRouteImport } from './routes/sales/quotes/index'
import { Route as SalesQuotesDocumentIdRouteImport } from './routes/sales/quotes/$documentId'
import { Route as SalesQuotesNewRouteImport } from './routes/sales/quotes/new'
import { Route as SalesReceivePaymentNewRouteImport } from './routes/sales/receive-payment/new'
import { Route as SalesSalesOrdersIndexRouteImport } from './routes/sales/sales-orders/index'
import { Route as SalesSalesOrdersDocumentIdRouteImport } from './routes/sales/sales-orders/$documentId'
import { Route as SalesSalesOrdersNewRouteImport } from './routes/sales/sales-orders/new'
import { Route as SalesSalesReceiptsDocumentIdRouteImport } from './routes/sales/sales-receipts/$documentId'
import { Route as SalesSalesReceiptsNewRouteImport } from './routes/sales/sales-receipts/new'
import { Route as SalesStatementsNewRouteImport } from './routes/sales/statements/new'
import { Route as SettingsImportIndexRouteImport } from './routes/settings/import/index'
import { Route as SettingsImportKindRouteImport } from './routes/settings/import/$kind'
import { Route as SettingsMigrationIndexRouteImport } from './routes/settings/migration/index'
import { Route as SettingsMigrationOpeningBalancesRouteImport } from './routes/settings/migration/opening-balances'
import { Route as SettingsMigrationTransactionsRouteImport } from './routes/settings/migration/transactions'
import { Route as TaxesGstIndexRouteImport } from './routes/taxes/gst/index'
import { Route as TaxesGstEwayBillsRouteImport } from './routes/taxes/gst/eway-bills'
import { Route as TaxesGstGstr1RouteImport } from './routes/taxes/gst/gstr1'
import { Route as TaxesGstGstr3bRouteImport } from './routes/taxes/gst/gstr3b'
import { Route as TaxesGstImsRouteImport } from './routes/taxes/gst/ims'
import { Route as TaxesVatIndexRouteImport } from './routes/taxes/vat/index'
import { Route as TaxesVatRatesRouteImport } from './routes/taxes/vat/rates'
import { Route as TaxesVatSettingsRouteImport } from './routes/taxes/vat/settings'
import { Route as AccountingChartOfAccountsAccountIdRegisterRouteImport } from './routes/accounting/chart-of-accounts/$accountId.register'
import { Route as AccountingPeriodsFiscalYearIdCloseRouteImport } from './routes/accounting/periods/$fiscalYearId.close'
import { Route as BankingReconcileReconciliationIdIndexRouteImport } from './routes/banking/reconcile/$reconciliationId/index'
import { Route as BankingReconcileReconciliationIdReportRouteImport } from './routes/banking/reconcile/$reconciliationId/report'
import { Route as SettingsMigrationHistoryIndexRouteImport } from './routes/settings/migration/history/index'
import { Route as SettingsMigrationHistoryRunIdRouteImport } from './routes/settings/migration/history/$runId'
import { Route as SettingsMigrationOpenItemsSideRouteImport } from './routes/settings/migration/open-items.$side'
import { Route as TaxesVatReturnsKeyRouteImport } from './routes/taxes/vat/returns/$key'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MessagesRoute = MessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingAuditLogRoute = AccountingAuditLogRouteImport.update({
  id: '/accounting/audit-log',
  path: '/accounting/audit-log',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingReclassifyRoute = AccountingReclassifyRouteImport.update({
  id: '/accounting/reclassify',
  path: '/accounting/reclassify',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingWriteOffInvoicesRoute =
  AccountingWriteOffInvoicesRouteImport.update({
    id: '/accounting/write-off-invoices',
    path: '/accounting/write-off-invoices',
    getParentRoute: () => rootRouteImport,
  } as any)
const AiAccountantIndexRoute = AiAccountantIndexRouteImport.update({
  id: '/ai-accountant/',
  path: '/ai-accountant/',
  getParentRoute: () => rootRouteImport,
} as any)
const AiAccountantIdRoute = AiAccountantIdRouteImport.update({
  id: '/ai-accountant/$id',
  path: '/ai-accountant/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const BankingIndexRoute = BankingIndexRouteImport.update({
  id: '/banking/',
  path: '/banking/',
  getParentRoute: () => rootRouteImport,
} as any)
const BankingImportRoute = BankingImportRouteImport.update({
  id: '/banking/import',
  path: '/banking/import',
  getParentRoute: () => rootRouteImport,
} as any)
const BankingRulesRoute = BankingRulesRouteImport.update({
  id: '/banking/rules',
  path: '/banking/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsApprovalsRoute = DocumentsApprovalsRouteImport.update({
  id: '/documents/approvals',
  path: '/documents/approvals',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsInboxRoute = DocumentsInboxRouteImport.update({
  id: '/documents/inbox',
  path: '/documents/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesIndexRoute = ExpensesIndexRouteImport.update({
  id: '/expenses/',
  path: '/expenses/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesPayBillsRoute = ExpensesPayBillsRouteImport.update({
  id: '/expenses/pay-bills',
  path: '/expenses/pay-bills',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpShortcutsRoute = HelpShortcutsRouteImport.update({
  id: '/help/shortcuts',
  path: '/help/shortcuts',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryAdjustRoute = InventoryAdjustRouteImport.update({
  id: '/inventory/adjust',
  path: '/inventory/adjust',
  getParentRoute: () => rootRouteImport,
} as any)
const PracticeClientsRoute = PracticeClientsRouteImport.update({
  id: '/practice/clients',
  path: '/practice/clients',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsReportKeyRoute = ReportsReportKeyRouteImport.update({
  id: '/reports/$reportKey',
  path: '/reports/$reportKey',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsVatDetailRoute = ReportsVatDetailRouteImport.update({
  id: '/reports/vat-detail',
  path: '/reports/vat-detail',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsVatExceptionRoute = ReportsVatExceptionRouteImport.update({
  id: '/reports/vat-exception',
  path: '/reports/vat-exception',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsVatSummaryRoute = ReportsVatSummaryRouteImport.update({
  id: '/reports/vat-summary',
  path: '/reports/vat-summary',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesIndexRoute = SalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesAllRoute = SalesAllRouteImport.update({
  id: '/sales/all',
  path: '/sales/all',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAttachmentsRoute = SettingsAttachmentsRouteImport.update({
  id: '/settings/attachments',
  path: '/settings/attachments',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsClassesRoute = SettingsClassesRouteImport.update({
  id: '/settings/classes',
  path: '/settings/classes',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsCompanyRoute = SettingsCompanyRouteImport.update({
  id: '/settings/company',
  path: '/settings/company',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsCurrenciesRoute = SettingsCurrenciesRouteImport.update({
  id: '/settings/currencies',
  path: '/settings/currencies',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsExportRoute = SettingsExportRouteImport.update({
  id: '/settings/export',
  path: '/settings/export',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsLocationsRoute = SettingsLocationsRouteImport.update({
  id: '/settings/locations',
  path: '/settings/locations',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/settings/notifications',
  path: '/settings/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSentEmailsRoute = SettingsSentEmailsRouteImport.update({
  id: '/settings/sent-emails',
  path: '/settings/sent-emails',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTagsRoute = SettingsTagsRouteImport.update({
  id: '/settings/tags',
  path: '/settings/tags',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => rootRouteImport,
} as any)
const TaxesCorporateTaxRoute = TaxesCorporateTaxRouteImport.update({
  id: '/taxes/corporate-tax',
  path: '/taxes/corporate-tax',
  getParentRoute: () => rootRouteImport,
} as any)
const TaxesEInvoicingRoute = TaxesEInvoicingRouteImport.update({
  id: '/taxes/e-invoicing',
  path: '/taxes/e-invoicing',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingBudgetsIndexRoute = AccountingBudgetsIndexRouteImport.update({
  id: '/accounting/budgets/',
  path: '/accounting/budgets/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingBudgetsBudgetIdRoute =
  AccountingBudgetsBudgetIdRouteImport.update({
    id: '/accounting/budgets/$budgetId',
    path: '/accounting/budgets/$budgetId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingChartOfAccountsIndexRoute =
  AccountingChartOfAccountsIndexRouteImport.update({
    id: '/accounting/chart-of-accounts/',
    path: '/accounting/chart-of-accounts/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingFixedAssetsIndexRoute =
  AccountingFixedAssetsIndexRouteImport.update({
    id: '/accounting/fixed-assets/',
    path: '/accounting/fixed-assets/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingFixedAssetsAssetIdRoute =
  AccountingFixedAssetsAssetIdRouteImport.update({
    id: '/accounting/fixed-assets/$assetId',
    path: '/accounting/fixed-assets/$assetId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingJournalEntriesIndexRoute =
  AccountingJournalEntriesIndexRouteImport.update({
    id: '/accounting/journal-entries/',
    path: '/accounting/journal-entries/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingJournalEntriesEntryIdRoute =
  AccountingJournalEntriesEntryIdRouteImport.update({
    id: '/accounting/journal-entries/$entryId',
    path: '/accounting/journal-entries/$entryId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingJournalEntriesNewRoute =
  AccountingJournalEntriesNewRouteImport.update({
    id: '/accounting/journal-entries/new',
    path: '/accounting/journal-entries/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingPeriodsIndexRoute = AccountingPeriodsIndexRouteImport.update({
  id: '/accounting/periods/',
  path: '/accounting/periods/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingRecurringIndexRoute =
  AccountingRecurringIndexRouteImport.update({
    id: '/accounting/recurring/',
    path: '/accounting/recurring/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingRecurringTemplateIdRoute =
  AccountingRecurringTemplateIdRouteImport.update({
    id: '/accounting/recurring/$templateId',
    path: '/accounting/recurring/$templateId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingRecurringNewRoute = AccountingRecurringNewRouteImport.update({
  id: '/accounting/recurring/new',
  path: '/accounting/recurring/new',
  getParentRoute: () => rootRouteImport,
} as any)
const BankingReconcileIndexRoute = BankingReconcileIndexRouteImport.update({
  id: '/banking/reconcile/',
  path: '/banking/reconcile/',
  getParentRoute: () => rootRouteImport,
} as any)
const BankingTransfersNewRoute = BankingTransfersNewRouteImport.update({
  id: '/banking/transfers/new',
  path: '/banking/transfers/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesBillsIndexRoute = ExpensesBillsIndexRouteImport.update({
  id: '/expenses/bills/',
  path: '/expenses/bills/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesBillsDocumentIdRoute = ExpensesBillsDocumentIdRouteImport.update({
  id: '/expenses/bills/$documentId',
  path: '/expenses/bills/$documentId',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesBillsNewRoute = ExpensesBillsNewRouteImport.update({
  id: '/expenses/bills/new',
  path: '/expenses/bills/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesDebitNotesDocumentIdRoute =
  ExpensesDebitNotesDocumentIdRouteImport.update({
    id: '/expenses/debit-notes/$documentId',
    path: '/expenses/debit-notes/$documentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExpensesDebitNotesNewRoute = ExpensesDebitNotesNewRouteImport.update({
  id: '/expenses/debit-notes/new',
  path: '/expenses/debit-notes/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesExpensesDocumentIdRoute =
  ExpensesExpensesDocumentIdRouteImport.update({
    id: '/expenses/expenses/$documentId',
    path: '/expenses/expenses/$documentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExpensesExpensesNewRoute = ExpensesExpensesNewRouteImport.update({
  id: '/expenses/expenses/new',
  path: '/expenses/expenses/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesPaymentsPaymentIdRoute =
  ExpensesPaymentsPaymentIdRouteImport.update({
    id: '/expenses/payments/$paymentId',
    path: '/expenses/payments/$paymentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExpensesPurchaseOrdersIndexRoute =
  ExpensesPurchaseOrdersIndexRouteImport.update({
    id: '/expenses/purchase-orders/',
    path: '/expenses/purchase-orders/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExpensesPurchaseOrdersDocumentIdRoute =
  ExpensesPurchaseOrdersDocumentIdRouteImport.update({
    id: '/expenses/purchase-orders/$documentId',
    path: '/expenses/purchase-orders/$documentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExpensesPurchaseOrdersNewRoute =
  ExpensesPurchaseOrdersNewRouteImport.update({
    id: '/expenses/purchase-orders/new',
    path: '/expenses/purchase-orders/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const ExpensesVendorsIndexRoute = ExpensesVendorsIndexRouteImport.update({
  id: '/expenses/vendors/',
  path: '/expenses/vendors/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesVendorsContactIdRoute =
  ExpensesVendorsContactIdRouteImport.update({
    id: '/expenses/vendors/$contactId',
    path: '/expenses/vendors/$contactId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ReportsManagementPackIdRoute = ReportsManagementPackIdRouteImport.update({
  id: '/reports/management/$packId',
  path: '/reports/management/$packId',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsManagementNewRoute = ReportsManagementNewRouteImport.update({
  id: '/reports/management/new',
  path: '/reports/management/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsParallelRunIndexRoute = ReportsParallelRunIndexRouteImport.update({
  id: '/reports/parallel-run/',
  path: '/reports/parallel-run/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsParallelRunRunIdRoute = ReportsParallelRunRunIdRouteImport.update({
  id: '/reports/parallel-run/$runId',
  path: '/reports/parallel-run/$runId',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesCreditNotesDocumentIdRoute =
  SalesCreditNotesDocumentIdRouteImport.update({
    id: '/sales/credit-notes/$documentId',
    path: '/sales/credit-notes/$documentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SalesCreditNotesNewRoute = SalesCreditNotesNewRouteImport.update({
  id: '/sales/credit-notes/new',
  path: '/sales/credit-notes/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesCustomersIndexRoute = SalesCustomersIndexRouteImport.update({
  id: '/sales/customers/',
  path: '/sales/customers/',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesCustomersContactIdRoute = SalesCustomersContactIdRouteImport.update({
  id: '/sales/customers/$contactId',
  path: '/sales/customers/$contactId',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesDeliveryChallansIndexRoute =
  SalesDeliveryChallansIndexRouteImport.update({
    id: '/sales/delivery-challans/',
    path: '/sales/delivery-challans/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SalesDeliveryChallansDocumentIdRoute =
  SalesDeliveryChallansDocumentIdRouteImport.update({
    id: '/sales/delivery-challans/$documentId',
    path: '/sales/delivery-challans/$documentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SalesDeliveryChallansNewRoute =
  SalesDeliveryChallansNewRouteImport.update({
    id: '/sales/delivery-challans/new',
    path: '/sales/delivery-challans/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const SalesInvoicesIndexRoute = SalesInvoicesIndexRouteImport.update({
  id: '/sales/invoices/',
  path: '/sales/invoices/',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesInvoicesDocumentIdRoute = SalesInvoicesDocumentIdRouteImport.update({
  id: '/sales/invoices/$documentId',
  path: '/sales/invoices/$documentId',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesInvoicesNewRoute = SalesInvoicesNewRouteImport.update({
  id: '/sales/invoices/new',
  path: '/sales/invoices/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesPaymentsPaymentIdRoute = SalesPaymentsPaymentIdRouteImport.update({
  id: '/sales/payments/$paymentId',
  path: '/sales/payments/$paymentId',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesProductsAndServicesIndexRoute =
  SalesProductsAndServicesIndexRouteImport.update({
    id: '/sales/products-and-services/',
    path: '/sales/products-and-services/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SalesQuotesIndexRoute = SalesQuotesIndexRouteImport.update({
  id: '/sales/quotes/',
  path: '/sales/quotes/',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesQuotesDocumentIdRoute = SalesQuotesDocumentIdRouteImport.update({
  id: '/sales/quotes/$documentId',
  path: '/sales/quotes/$documentId',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesQuotesNewRoute = SalesQuotesNewRouteImport.update({
  id: '/sales/quotes/new',
  path: '/sales/quotes/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesReceivePaymentNewRoute = SalesReceivePaymentNewRouteImport.update({
  id: '/sales/receive-payment/new',
  path: '/sales/receive-payment/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesSalesOrdersIndexRoute = SalesSalesOrdersIndexRouteImport.update({
  id: '/sales/sales-orders/',
  path: '/sales/sales-orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesSalesOrdersDocumentIdRoute =
  SalesSalesOrdersDocumentIdRouteImport.update({
    id: '/sales/sales-orders/$documentId',
    path: '/sales/sales-orders/$documentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SalesSalesOrdersNewRoute = SalesSalesOrdersNewRouteImport.update({
  id: '/sales/sales-orders/new',
  path: '/sales/sales-orders/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesSalesReceiptsDocumentIdRoute =
  SalesSalesReceiptsDocumentIdRouteImport.update({
    id: '/sales/sales-receipts/$documentId',
    path: '/sales/sales-receipts/$documentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SalesSalesReceiptsNewRoute = SalesSalesReceiptsNewRouteImport.update({
  id: '/sales/sales-receipts/new',
  path: '/sales/sales-receipts/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesStatementsNewRoute = SalesStatementsNewRouteImport.update({
  id: '/sales/statements/new',
  path: '/sales/statements/new',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsImportIndexRoute = SettingsImportIndexRouteImport.update({
  id: '/settings/import/',
  path: '/settings/import/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsImportKindRoute = SettingsImportKindRouteImport.update({
  id: '/settings/import/$kind',
  path: '/settings/import/$kind',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMigrationIndexRoute = SettingsMigrationIndexRouteImport.update({
  id: '/settings/migration/',
  path: '/settings/migration/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMigrationOpeningBalancesRoute =
  SettingsMigrationOpeningBalancesRouteImport.update({
    id: '/settings/migration/opening-balances',
    path: '/settings/migration/opening-balances',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsMigrationTransactionsRoute =
  SettingsMigrationTransactionsRouteImport.update({
    id: '/settings/migration/transactions',
    path: '/settings/migration/transactions',
    getParentRoute: () => rootRouteImport,
  } as any)
const TaxesGstIndexRoute = TaxesGstIndexRouteImport.update({
  id: '/taxes/gst/',
  path: '/taxes/gst/',
  getParentRoute: () => rootRouteImport,
} as any)
const TaxesGstEwayBillsRoute = TaxesGstEwayBillsRouteImport.update({
  id: '/taxes/gst/eway-bills',
  path: '/taxes/gst/eway-bills',
  getParentRoute: () => rootRouteImport,
} as any)
const TaxesGstGstr1Route = TaxesGstGstr1RouteImport.update({
  id: '/taxes/gst/gstr1',
  path: '/taxes/gst/gstr1',
  getParentRoute: () => rootRouteImport,
} as any)
const TaxesGstGstr3bRoute = TaxesGstGstr3bRouteImport.update({
  id: '/taxes/gst/gstr3b',
  path: '/taxes/gst/gstr3b',
  getParentRoute: () => rootRouteImport,
} as any)
const TaxesGstImsRoute = TaxesGstImsRouteImport.update({
  id: '/taxes/gst/ims',
  path: '/taxes/gst/ims',
  getParentRoute: () => rootRouteImport,
} as any)
const TaxesVatIndexRoute = TaxesVatIndexRouteImport.update({
  id: '/taxes/vat/',
  path: '/taxes/vat/',
  getParentRoute: () => rootRouteImport,
} as any)
const TaxesVatRatesRoute = TaxesVatRatesRouteImport.update({
  id: '/taxes/vat/rates',
  path: '/taxes/vat/rates',
  getParentRoute: () => rootRouteImport,
} as any)
const TaxesVatSettingsRoute = TaxesVatSettingsRouteImport.update({
  id: '/taxes/vat/settings',
  path: '/taxes/vat/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingChartOfAccountsAccountIdRegisterRoute =
  AccountingChartOfAccountsAccountIdRegisterRouteImport.update({
    id: '/accounting/chart-of-accounts/$accountId/register',
    path: '/accounting/chart-of-accounts/$accountId/register',
    getParentRoute: () => rootRouteImport,
  } as any)
const AccountingPeriodsFiscalYearIdCloseRoute =
  AccountingPeriodsFiscalYearIdCloseRouteImport.update({
    id: '/accounting/periods/$fiscalYearId/close',
    path: '/accounting/periods/$fiscalYearId/close',
    getParentRoute: () => rootRouteImport,
  } as any)
const BankingReconcileReconciliationIdIndexRoute =
  BankingReconcileReconciliationIdIndexRouteImport.update({
    id: '/banking/reconcile/$reconciliationId/',
    path: '/banking/reconcile/$reconciliationId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BankingReconcileReconciliationIdReportRoute =
  BankingReconcileReconciliationIdReportRouteImport.update({
    id: '/banking/reconcile/$reconciliationId/report',
    path: '/banking/reconcile/$reconciliationId/report',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsMigrationHistoryIndexRoute =
  SettingsMigrationHistoryIndexRouteImport.update({
    id: '/settings/migration/history/',
    path: '/settings/migration/history/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsMigrationHistoryRunIdRoute =
  SettingsMigrationHistoryRunIdRouteImport.update({
    id: '/settings/migration/history/$runId',
    path: '/settings/migration/history/$runId',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsMigrationOpenItemsSideRoute =
  SettingsMigrationOpenItemsSideRouteImport.update({
    id: '/settings/migration/open-items/$side',
    path: '/settings/migration/open-items/$side',
    getParentRoute: () => rootRouteImport,
  } as any)
const TaxesVatReturnsKeyRoute = TaxesVatReturnsKeyRouteImport.update({
  id: '/taxes/vat/returns/$key',
  path: '/taxes/vat/returns/$key',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/login': typeof LoginRoute
  '/messages': typeof MessagesRoute
  '/onboarding': typeof OnboardingRoute
  '/signup': typeof SignupRoute
  '/accounting/audit-log': typeof AccountingAuditLogRoute
  '/accounting/reclassify': typeof AccountingReclassifyRoute
  '/accounting/write-off-invoices': typeof AccountingWriteOffInvoicesRoute
  '/ai-accountant/$id': typeof AiAccountantIdRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/banking/import': typeof BankingImportRoute
  '/banking/rules': typeof BankingRulesRoute
  '/documents/approvals': typeof DocumentsApprovalsRoute
  '/documents/inbox': typeof DocumentsInboxRoute
  '/expenses/pay-bills': typeof ExpensesPayBillsRoute
  '/help/shortcuts': typeof HelpShortcutsRoute
  '/inventory/adjust': typeof InventoryAdjustRoute
  '/practice/clients': typeof PracticeClientsRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/reports/$reportKey': typeof ReportsReportKeyRoute
  '/reports/vat-detail': typeof ReportsVatDetailRoute
  '/reports/vat-exception': typeof ReportsVatExceptionRoute
  '/reports/vat-summary': typeof ReportsVatSummaryRoute
  '/sales/all': typeof SalesAllRoute
  '/settings/attachments': typeof SettingsAttachmentsRoute
  '/settings/classes': typeof SettingsClassesRoute
  '/settings/company': typeof SettingsCompanyRoute
  '/settings/currencies': typeof SettingsCurrenciesRoute
  '/settings/export': typeof SettingsExportRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/sent-emails': typeof SettingsSentEmailsRoute
  '/settings/tags': typeof SettingsTagsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/taxes/corporate-tax': typeof TaxesCorporateTaxRoute
  '/taxes/e-invoicing': typeof TaxesEInvoicingRoute
  '/ai-accountant/': typeof AiAccountantIndexRoute
  '/banking/': typeof BankingIndexRoute
  '/expenses/': typeof ExpensesIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/sales/': typeof SalesIndexRoute
  '/accounting/budgets/$budgetId': typeof AccountingBudgetsBudgetIdRoute
  '/accounting/fixed-assets/$assetId': typeof AccountingFixedAssetsAssetIdRoute
  '/accounting/journal-entries/$entryId': typeof AccountingJournalEntriesEntryIdRoute
  '/accounting/journal-entries/new': typeof AccountingJournalEntriesNewRoute
  '/accounting/recurring/$templateId': typeof AccountingRecurringTemplateIdRoute
  '/accounting/recurring/new': typeof AccountingRecurringNewRoute
  '/banking/transfers/new': typeof BankingTransfersNewRoute
  '/expenses/bills/$documentId': typeof ExpensesBillsDocumentIdRoute
  '/expenses/bills/new': typeof ExpensesBillsNewRoute
  '/expenses/debit-notes/$documentId': typeof ExpensesDebitNotesDocumentIdRoute
  '/expenses/debit-notes/new': typeof ExpensesDebitNotesNewRoute
  '/expenses/expenses/$documentId': typeof ExpensesExpensesDocumentIdRoute
  '/expenses/expenses/new': typeof ExpensesExpensesNewRoute
  '/expenses/payments/$paymentId': typeof ExpensesPaymentsPaymentIdRoute
  '/expenses/purchase-orders/$documentId': typeof ExpensesPurchaseOrdersDocumentIdRoute
  '/expenses/purchase-orders/new': typeof ExpensesPurchaseOrdersNewRoute
  '/expenses/vendors/$contactId': typeof ExpensesVendorsContactIdRoute
  '/reports/management/$packId': typeof ReportsManagementPackIdRoute
  '/reports/management/new': typeof ReportsManagementNewRoute
  '/reports/parallel-run/$runId': typeof ReportsParallelRunRunIdRoute
  '/sales/credit-notes/$documentId': typeof SalesCreditNotesDocumentIdRoute
  '/sales/credit-notes/new': typeof SalesCreditNotesNewRoute
  '/sales/customers/$contactId': typeof SalesCustomersContactIdRoute
  '/sales/delivery-challans/$documentId': typeof SalesDeliveryChallansDocumentIdRoute
  '/sales/delivery-challans/new': typeof SalesDeliveryChallansNewRoute
  '/sales/invoices/$documentId': typeof SalesInvoicesDocumentIdRoute
  '/sales/invoices/new': typeof SalesInvoicesNewRoute
  '/sales/payments/$paymentId': typeof SalesPaymentsPaymentIdRoute
  '/sales/quotes/$documentId': typeof SalesQuotesDocumentIdRoute
  '/sales/quotes/new': typeof SalesQuotesNewRoute
  '/sales/receive-payment/new': typeof SalesReceivePaymentNewRoute
  '/sales/sales-orders/$documentId': typeof SalesSalesOrdersDocumentIdRoute
  '/sales/sales-orders/new': typeof SalesSalesOrdersNewRoute
  '/sales/sales-receipts/$documentId': typeof SalesSalesReceiptsDocumentIdRoute
  '/sales/sales-receipts/new': typeof SalesSalesReceiptsNewRoute
  '/sales/statements/new': typeof SalesStatementsNewRoute
  '/settings/import/$kind': typeof SettingsImportKindRoute
  '/settings/migration/opening-balances': typeof SettingsMigrationOpeningBalancesRoute
  '/settings/migration/transactions': typeof SettingsMigrationTransactionsRoute
  '/taxes/gst/eway-bills': typeof TaxesGstEwayBillsRoute
  '/taxes/gst/gstr1': typeof TaxesGstGstr1Route
  '/taxes/gst/gstr3b': typeof TaxesGstGstr3bRoute
  '/taxes/gst/ims': typeof TaxesGstImsRoute
  '/taxes/vat/rates': typeof TaxesVatRatesRoute
  '/taxes/vat/settings': typeof TaxesVatSettingsRoute
  '/accounting/budgets/': typeof AccountingBudgetsIndexRoute
  '/accounting/chart-of-accounts/': typeof AccountingChartOfAccountsIndexRoute
  '/accounting/fixed-assets/': typeof AccountingFixedAssetsIndexRoute
  '/accounting/journal-entries/': typeof AccountingJournalEntriesIndexRoute
  '/accounting/periods/': typeof AccountingPeriodsIndexRoute
  '/accounting/recurring/': typeof AccountingRecurringIndexRoute
  '/banking/reconcile/': typeof BankingReconcileIndexRoute
  '/expenses/bills/': typeof ExpensesBillsIndexRoute
  '/expenses/purchase-orders/': typeof ExpensesPurchaseOrdersIndexRoute
  '/expenses/vendors/': typeof ExpensesVendorsIndexRoute
  '/reports/parallel-run/': typeof ReportsParallelRunIndexRoute
  '/sales/customers/': typeof SalesCustomersIndexRoute
  '/sales/delivery-challans/': typeof SalesDeliveryChallansIndexRoute
  '/sales/invoices/': typeof SalesInvoicesIndexRoute
  '/sales/products-and-services/': typeof SalesProductsAndServicesIndexRoute
  '/sales/quotes/': typeof SalesQuotesIndexRoute
  '/sales/sales-orders/': typeof SalesSalesOrdersIndexRoute
  '/settings/import/': typeof SettingsImportIndexRoute
  '/settings/migration/': typeof SettingsMigrationIndexRoute
  '/taxes/gst/': typeof TaxesGstIndexRoute
  '/taxes/vat/': typeof TaxesVatIndexRoute
  '/accounting/chart-of-accounts/$accountId/register': typeof AccountingChartOfAccountsAccountIdRegisterRoute
  '/accounting/periods/$fiscalYearId/close': typeof AccountingPeriodsFiscalYearIdCloseRoute
  '/banking/reconcile/$reconciliationId/report': typeof BankingReconcileReconciliationIdReportRoute
  '/settings/migration/history/$runId': typeof SettingsMigrationHistoryRunIdRoute
  '/settings/migration/open-items/$side': typeof SettingsMigrationOpenItemsSideRoute
  '/taxes/vat/returns/$key': typeof TaxesVatReturnsKeyRoute
  '/banking/reconcile/$reconciliationId/': typeof BankingReconcileReconciliationIdIndexRoute
  '/settings/migration/history/': typeof SettingsMigrationHistoryIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/login': typeof LoginRoute
  '/messages': typeof MessagesRoute
  '/onboarding': typeof OnboardingRoute
  '/signup': typeof SignupRoute
  '/accounting/audit-log': typeof AccountingAuditLogRoute
  '/accounting/reclassify': typeof AccountingReclassifyRoute
  '/accounting/write-off-invoices': typeof AccountingWriteOffInvoicesRoute
  '/ai-accountant/$id': typeof AiAccountantIdRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/banking/import': typeof BankingImportRoute
  '/banking/rules': typeof BankingRulesRoute
  '/documents/approvals': typeof DocumentsApprovalsRoute
  '/documents/inbox': typeof DocumentsInboxRoute
  '/expenses/pay-bills': typeof ExpensesPayBillsRoute
  '/help/shortcuts': typeof HelpShortcutsRoute
  '/inventory/adjust': typeof InventoryAdjustRoute
  '/practice/clients': typeof PracticeClientsRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/reports/$reportKey': typeof ReportsReportKeyRoute
  '/reports/vat-detail': typeof ReportsVatDetailRoute
  '/reports/vat-exception': typeof ReportsVatExceptionRoute
  '/reports/vat-summary': typeof ReportsVatSummaryRoute
  '/sales/all': typeof SalesAllRoute
  '/settings/attachments': typeof SettingsAttachmentsRoute
  '/settings/classes': typeof SettingsClassesRoute
  '/settings/company': typeof SettingsCompanyRoute
  '/settings/currencies': typeof SettingsCurrenciesRoute
  '/settings/export': typeof SettingsExportRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/sent-emails': typeof SettingsSentEmailsRoute
  '/settings/tags': typeof SettingsTagsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/taxes/corporate-tax': typeof TaxesCorporateTaxRoute
  '/taxes/e-invoicing': typeof TaxesEInvoicingRoute
  '/ai-accountant': typeof AiAccountantIndexRoute
  '/banking': typeof BankingIndexRoute
  '/expenses': typeof ExpensesIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/sales': typeof SalesIndexRoute
  '/accounting/budgets/$budgetId': typeof AccountingBudgetsBudgetIdRoute
  '/accounting/fixed-assets/$assetId': typeof AccountingFixedAssetsAssetIdRoute
  '/accounting/journal-entries/$entryId': typeof AccountingJournalEntriesEntryIdRoute
  '/accounting/journal-entries/new': typeof AccountingJournalEntriesNewRoute
  '/accounting/recurring/$templateId': typeof AccountingRecurringTemplateIdRoute
  '/accounting/recurring/new': typeof AccountingRecurringNewRoute
  '/banking/transfers/new': typeof BankingTransfersNewRoute
  '/expenses/bills/$documentId': typeof ExpensesBillsDocumentIdRoute
  '/expenses/bills/new': typeof ExpensesBillsNewRoute
  '/expenses/debit-notes/$documentId': typeof ExpensesDebitNotesDocumentIdRoute
  '/expenses/debit-notes/new': typeof ExpensesDebitNotesNewRoute
  '/expenses/expenses/$documentId': typeof ExpensesExpensesDocumentIdRoute
  '/expenses/expenses/new': typeof ExpensesExpensesNewRoute
  '/expenses/payments/$paymentId': typeof ExpensesPaymentsPaymentIdRoute
  '/expenses/purchase-orders/$documentId': typeof ExpensesPurchaseOrdersDocumentIdRoute
  '/expenses/purchase-orders/new': typeof ExpensesPurchaseOrdersNewRoute
  '/expenses/vendors/$contactId': typeof ExpensesVendorsContactIdRoute
  '/reports/management/$packId': typeof ReportsManagementPackIdRoute
  '/reports/management/new': typeof ReportsManagementNewRoute
  '/reports/parallel-run/$runId': typeof ReportsParallelRunRunIdRoute
  '/sales/credit-notes/$documentId': typeof SalesCreditNotesDocumentIdRoute
  '/sales/credit-notes/new': typeof SalesCreditNotesNewRoute
  '/sales/customers/$contactId': typeof SalesCustomersContactIdRoute
  '/sales/delivery-challans/$documentId': typeof SalesDeliveryChallansDocumentIdRoute
  '/sales/delivery-challans/new': typeof SalesDeliveryChallansNewRoute
  '/sales/invoices/$documentId': typeof SalesInvoicesDocumentIdRoute
  '/sales/invoices/new': typeof SalesInvoicesNewRoute
  '/sales/payments/$paymentId': typeof SalesPaymentsPaymentIdRoute
  '/sales/quotes/$documentId': typeof SalesQuotesDocumentIdRoute
  '/sales/quotes/new': typeof SalesQuotesNewRoute
  '/sales/receive-payment/new': typeof SalesReceivePaymentNewRoute
  '/sales/sales-orders/$documentId': typeof SalesSalesOrdersDocumentIdRoute
  '/sales/sales-orders/new': typeof SalesSalesOrdersNewRoute
  '/sales/sales-receipts/$documentId': typeof SalesSalesReceiptsDocumentIdRoute
  '/sales/sales-receipts/new': typeof SalesSalesReceiptsNewRoute
  '/sales/statements/new': typeof SalesStatementsNewRoute
  '/settings/import/$kind': typeof SettingsImportKindRoute
  '/settings/migration/opening-balances': typeof SettingsMigrationOpeningBalancesRoute
  '/settings/migration/transactions': typeof SettingsMigrationTransactionsRoute
  '/taxes/gst/eway-bills': typeof TaxesGstEwayBillsRoute
  '/taxes/gst/gstr1': typeof TaxesGstGstr1Route
  '/taxes/gst/gstr3b': typeof TaxesGstGstr3bRoute
  '/taxes/gst/ims': typeof TaxesGstImsRoute
  '/taxes/vat/rates': typeof TaxesVatRatesRoute
  '/taxes/vat/settings': typeof TaxesVatSettingsRoute
  '/accounting/budgets': typeof AccountingBudgetsIndexRoute
  '/accounting/chart-of-accounts': typeof AccountingChartOfAccountsIndexRoute
  '/accounting/fixed-assets': typeof AccountingFixedAssetsIndexRoute
  '/accounting/journal-entries': typeof AccountingJournalEntriesIndexRoute
  '/accounting/periods': typeof AccountingPeriodsIndexRoute
  '/accounting/recurring': typeof AccountingRecurringIndexRoute
  '/banking/reconcile': typeof BankingReconcileIndexRoute
  '/expenses/bills': typeof ExpensesBillsIndexRoute
  '/expenses/purchase-orders': typeof ExpensesPurchaseOrdersIndexRoute
  '/expenses/vendors': typeof ExpensesVendorsIndexRoute
  '/reports/parallel-run': typeof ReportsParallelRunIndexRoute
  '/sales/customers': typeof SalesCustomersIndexRoute
  '/sales/delivery-challans': typeof SalesDeliveryChallansIndexRoute
  '/sales/invoices': typeof SalesInvoicesIndexRoute
  '/sales/products-and-services': typeof SalesProductsAndServicesIndexRoute
  '/sales/quotes': typeof SalesQuotesIndexRoute
  '/sales/sales-orders': typeof SalesSalesOrdersIndexRoute
  '/settings/import': typeof SettingsImportIndexRoute
  '/settings/migration': typeof SettingsMigrationIndexRoute
  '/taxes/gst': typeof TaxesGstIndexRoute
  '/taxes/vat': typeof TaxesVatIndexRoute
  '/accounting/chart-of-accounts/$accountId/register': typeof AccountingChartOfAccountsAccountIdRegisterRoute
  '/accounting/periods/$fiscalYearId/close': typeof AccountingPeriodsFiscalYearIdCloseRoute
  '/banking/reconcile/$reconciliationId/report': typeof BankingReconcileReconciliationIdReportRoute
  '/settings/migration/history/$runId': typeof SettingsMigrationHistoryRunIdRoute
  '/settings/migration/open-items/$side': typeof SettingsMigrationOpenItemsSideRoute
  '/taxes/vat/returns/$key': typeof TaxesVatReturnsKeyRoute
  '/banking/reconcile/$reconciliationId': typeof BankingReconcileReconciliationIdIndexRoute
  '/settings/migration/history': typeof SettingsMigrationHistoryIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/login': typeof LoginRoute
  '/messages': typeof MessagesRoute
  '/onboarding': typeof OnboardingRoute
  '/signup': typeof SignupRoute
  '/accounting/audit-log': typeof AccountingAuditLogRoute
  '/accounting/reclassify': typeof AccountingReclassifyRoute
  '/accounting/write-off-invoices': typeof AccountingWriteOffInvoicesRoute
  '/ai-accountant/$id': typeof AiAccountantIdRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/banking/import': typeof BankingImportRoute
  '/banking/rules': typeof BankingRulesRoute
  '/documents/approvals': typeof DocumentsApprovalsRoute
  '/documents/inbox': typeof DocumentsInboxRoute
  '/expenses/pay-bills': typeof ExpensesPayBillsRoute
  '/help/shortcuts': typeof HelpShortcutsRoute
  '/inventory/adjust': typeof InventoryAdjustRoute
  '/practice/clients': typeof PracticeClientsRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/reports/$reportKey': typeof ReportsReportKeyRoute
  '/reports/vat-detail': typeof ReportsVatDetailRoute
  '/reports/vat-exception': typeof ReportsVatExceptionRoute
  '/reports/vat-summary': typeof ReportsVatSummaryRoute
  '/sales/all': typeof SalesAllRoute
  '/settings/attachments': typeof SettingsAttachmentsRoute
  '/settings/classes': typeof SettingsClassesRoute
  '/settings/company': typeof SettingsCompanyRoute
  '/settings/currencies': typeof SettingsCurrenciesRoute
  '/settings/export': typeof SettingsExportRoute
  '/settings/locations': typeof SettingsLocationsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/sent-emails': typeof SettingsSentEmailsRoute
  '/settings/tags': typeof SettingsTagsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/taxes/corporate-tax': typeof TaxesCorporateTaxRoute
  '/taxes/e-invoicing': typeof TaxesEInvoicingRoute
  '/ai-accountant/': typeof AiAccountantIndexRoute
  '/banking/': typeof BankingIndexRoute
  '/expenses/': typeof ExpensesIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/sales/': typeof SalesIndexRoute
  '/accounting/budgets/$budgetId': typeof AccountingBudgetsBudgetIdRoute
  '/accounting/fixed-assets/$assetId': typeof AccountingFixedAssetsAssetIdRoute
  '/accounting/journal-entries/$entryId': typeof AccountingJournalEntriesEntryIdRoute
  '/accounting/journal-entries/new': typeof AccountingJournalEntriesNewRoute
  '/accounting/recurring/$templateId': typeof AccountingRecurringTemplateIdRoute
  '/accounting/recurring/new': typeof AccountingRecurringNewRoute
  '/banking/transfers/new': typeof BankingTransfersNewRoute
  '/expenses/bills/$documentId': typeof ExpensesBillsDocumentIdRoute
  '/expenses/bills/new': typeof ExpensesBillsNewRoute
  '/expenses/debit-notes/$documentId': typeof ExpensesDebitNotesDocumentIdRoute
  '/expenses/debit-notes/new': typeof ExpensesDebitNotesNewRoute
  '/expenses/expenses/$documentId': typeof ExpensesExpensesDocumentIdRoute
  '/expenses/expenses/new': typeof ExpensesExpensesNewRoute
  '/expenses/payments/$paymentId': typeof ExpensesPaymentsPaymentIdRoute
  '/expenses/purchase-orders/$documentId': typeof ExpensesPurchaseOrdersDocumentIdRoute
  '/expenses/purchase-orders/new': typeof ExpensesPurchaseOrdersNewRoute
  '/expenses/vendors/$contactId': typeof ExpensesVendorsContactIdRoute
  '/reports/management/$packId': typeof ReportsManagementPackIdRoute
  '/reports/management/new': typeof ReportsManagementNewRoute
  '/reports/parallel-run/$runId': typeof ReportsParallelRunRunIdRoute
  '/sales/credit-notes/$documentId': typeof SalesCreditNotesDocumentIdRoute
  '/sales/credit-notes/new': typeof SalesCreditNotesNewRoute
  '/sales/customers/$contactId': typeof SalesCustomersContactIdRoute
  '/sales/delivery-challans/$documentId': typeof SalesDeliveryChallansDocumentIdRoute
  '/sales/delivery-challans/new': typeof SalesDeliveryChallansNewRoute
  '/sales/invoices/$documentId': typeof SalesInvoicesDocumentIdRoute
  '/sales/invoices/new': typeof SalesInvoicesNewRoute
  '/sales/payments/$paymentId': typeof SalesPaymentsPaymentIdRoute
  '/sales/quotes/$documentId': typeof SalesQuotesDocumentIdRoute
  '/sales/quotes/new': typeof SalesQuotesNewRoute
  '/sales/receive-payment/new': typeof SalesReceivePaymentNewRoute
  '/sales/sales-orders/$documentId': typeof SalesSalesOrdersDocumentIdRoute
  '/sales/sales-orders/new': typeof SalesSalesOrdersNewRoute
  '/sales/sales-receipts/$documentId': typeof SalesSalesReceiptsDocumentIdRoute
  '/sales/sales-receipts/new': typeof SalesSalesReceiptsNewRoute
  '/sales/statements/new': typeof SalesStatementsNewRoute
  '/settings/import/$kind': typeof SettingsImportKindRoute
  '/settings/migration/opening-balances': typeof SettingsMigrationOpeningBalancesRoute
  '/settings/migration/transactions': typeof SettingsMigrationTransactionsRoute
  '/taxes/gst/eway-bills': typeof TaxesGstEwayBillsRoute
  '/taxes/gst/gstr1': typeof TaxesGstGstr1Route
  '/taxes/gst/gstr3b': typeof TaxesGstGstr3bRoute
  '/taxes/gst/ims': typeof TaxesGstImsRoute
  '/taxes/vat/rates': typeof TaxesVatRatesRoute
  '/taxes/vat/settings': typeof TaxesVatSettingsRoute
  '/accounting/budgets/': typeof AccountingBudgetsIndexRoute
  '/accounting/chart-of-accounts/': typeof AccountingChartOfAccountsIndexRoute
  '/accounting/fixed-assets/': typeof AccountingFixedAssetsIndexRoute
  '/accounting/journal-entries/': typeof AccountingJournalEntriesIndexRoute
  '/accounting/periods/': typeof AccountingPeriodsIndexRoute
  '/accounting/recurring/': typeof AccountingRecurringIndexRoute
  '/banking/reconcile/': typeof BankingReconcileIndexRoute
  '/expenses/bills/': typeof ExpensesBillsIndexRoute
  '/expenses/purchase-orders/': typeof ExpensesPurchaseOrdersIndexRoute
  '/expenses/vendors/': typeof ExpensesVendorsIndexRoute
  '/reports/parallel-run/': typeof ReportsParallelRunIndexRoute
  '/sales/customers/': typeof SalesCustomersIndexRoute
  '/sales/delivery-challans/': typeof SalesDeliveryChallansIndexRoute
  '/sales/invoices/': typeof SalesInvoicesIndexRoute
  '/sales/products-and-services/': typeof SalesProductsAndServicesIndexRoute
  '/sales/quotes/': typeof SalesQuotesIndexRoute
  '/sales/sales-orders/': typeof SalesSalesOrdersIndexRoute
  '/settings/import/': typeof SettingsImportIndexRoute
  '/settings/migration/': typeof SettingsMigrationIndexRoute
  '/taxes/gst/': typeof TaxesGstIndexRoute
  '/taxes/vat/': typeof TaxesVatIndexRoute
  '/accounting/chart-of-accounts/$accountId/register': typeof AccountingChartOfAccountsAccountIdRegisterRoute
  '/accounting/periods/$fiscalYearId/close': typeof AccountingPeriodsFiscalYearIdCloseRoute
  '/banking/reconcile/$reconciliationId/report': typeof BankingReconcileReconciliationIdReportRoute
  '/settings/migration/history/$runId': typeof SettingsMigrationHistoryRunIdRoute
  '/settings/migration/open-items/$side': typeof SettingsMigrationOpenItemsSideRoute
  '/taxes/vat/returns/$key': typeof TaxesVatReturnsKeyRoute
  '/banking/reconcile/$reconciliationId/': typeof BankingReconcileReconciliationIdIndexRoute
  '/settings/migration/history/': typeof SettingsMigrationHistoryIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/dashboard'
    | '/demo'
    | '/login'
    | '/messages'
    | '/onboarding'
    | '/signup'
    | '/accounting/audit-log'
    | '/accounting/reclassify'
    | '/accounting/write-off-invoices'
    | '/ai-accountant/$id'
    | '/auth/callback'
    | '/banking/import'
    | '/banking/rules'
    | '/documents/approvals'
    | '/documents/inbox'
    | '/expenses/pay-bills'
    | '/help/shortcuts'
    | '/inventory/adjust'
    | '/practice/clients'
    | '/projects/$projectId'
    | '/reports/$reportKey'
    | '/reports/vat-detail'
    | '/reports/vat-exception'
    | '/reports/vat-summary'
    | '/sales/all'
    | '/settings/attachments'
    | '/settings/classes'
    | '/settings/company'
    | '/settings/currencies'
    | '/settings/export'
    | '/settings/locations'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/sent-emails'
    | '/settings/tags'
    | '/settings/users'
    | '/taxes/corporate-tax'
    | '/taxes/e-invoicing'
    | '/ai-accountant/'
    | '/banking/'
    | '/expenses/'
    | '/projects/'
    | '/reports/'
    | '/sales/'
    | '/accounting/budgets/$budgetId'
    | '/accounting/fixed-assets/$assetId'
    | '/accounting/journal-entries/$entryId'
    | '/accounting/journal-entries/new'
    | '/accounting/recurring/$templateId'
    | '/accounting/recurring/new'
    | '/banking/transfers/new'
    | '/expenses/bills/$documentId'
    | '/expenses/bills/new'
    | '/expenses/debit-notes/$documentId'
    | '/expenses/debit-notes/new'
    | '/expenses/expenses/$documentId'
    | '/expenses/expenses/new'
    | '/expenses/payments/$paymentId'
    | '/expenses/purchase-orders/$documentId'
    | '/expenses/purchase-orders/new'
    | '/expenses/vendors/$contactId'
    | '/reports/management/$packId'
    | '/reports/management/new'
    | '/reports/parallel-run/$runId'
    | '/sales/credit-notes/$documentId'
    | '/sales/credit-notes/new'
    | '/sales/customers/$contactId'
    | '/sales/delivery-challans/$documentId'
    | '/sales/delivery-challans/new'
    | '/sales/invoices/$documentId'
    | '/sales/invoices/new'
    | '/sales/payments/$paymentId'
    | '/sales/quotes/$documentId'
    | '/sales/quotes/new'
    | '/sales/receive-payment/new'
    | '/sales/sales-orders/$documentId'
    | '/sales/sales-orders/new'
    | '/sales/sales-receipts/$documentId'
    | '/sales/sales-receipts/new'
    | '/sales/statements/new'
    | '/settings/import/$kind'
    | '/settings/migration/opening-balances'
    | '/settings/migration/transactions'
    | '/taxes/gst/eway-bills'
    | '/taxes/gst/gstr1'
    | '/taxes/gst/gstr3b'
    | '/taxes/gst/ims'
    | '/taxes/vat/rates'
    | '/taxes/vat/settings'
    | '/accounting/budgets/'
    | '/accounting/chart-of-accounts/'
    | '/accounting/fixed-assets/'
    | '/accounting/journal-entries/'
    | '/accounting/periods/'
    | '/accounting/recurring/'
    | '/banking/reconcile/'
    | '/expenses/bills/'
    | '/expenses/purchase-orders/'
    | '/expenses/vendors/'
    | '/reports/parallel-run/'
    | '/sales/customers/'
    | '/sales/delivery-challans/'
    | '/sales/invoices/'
    | '/sales/products-and-services/'
    | '/sales/quotes/'
    | '/sales/sales-orders/'
    | '/settings/import/'
    | '/settings/migration/'
    | '/taxes/gst/'
    | '/taxes/vat/'
    | '/accounting/chart-of-accounts/$accountId/register'
    | '/accounting/periods/$fiscalYearId/close'
    | '/banking/reconcile/$reconciliationId/report'
    | '/settings/migration/history/$runId'
    | '/settings/migration/open-items/$side'
    | '/taxes/vat/returns/$key'
    | '/banking/reconcile/$reconciliationId/'
    | '/settings/migration/history/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/dashboard'
    | '/demo'
    | '/login'
    | '/messages'
    | '/onboarding'
    | '/signup'
    | '/accounting/audit-log'
    | '/accounting/reclassify'
    | '/accounting/write-off-invoices'
    | '/ai-accountant/$id'
    | '/auth/callback'
    | '/banking/import'
    | '/banking/rules'
    | '/documents/approvals'
    | '/documents/inbox'
    | '/expenses/pay-bills'
    | '/help/shortcuts'
    | '/inventory/adjust'
    | '/practice/clients'
    | '/projects/$projectId'
    | '/reports/$reportKey'
    | '/reports/vat-detail'
    | '/reports/vat-exception'
    | '/reports/vat-summary'
    | '/sales/all'
    | '/settings/attachments'
    | '/settings/classes'
    | '/settings/company'
    | '/settings/currencies'
    | '/settings/export'
    | '/settings/locations'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/sent-emails'
    | '/settings/tags'
    | '/settings/users'
    | '/taxes/corporate-tax'
    | '/taxes/e-invoicing'
    | '/ai-accountant'
    | '/banking'
    | '/expenses'
    | '/projects'
    | '/reports'
    | '/sales'
    | '/accounting/budgets/$budgetId'
    | '/accounting/fixed-assets/$assetId'
    | '/accounting/journal-entries/$entryId'
    | '/accounting/journal-entries/new'
    | '/accounting/recurring/$templateId'
    | '/accounting/recurring/new'
    | '/banking/transfers/new'
    | '/expenses/bills/$documentId'
    | '/expenses/bills/new'
    | '/expenses/debit-notes/$documentId'
    | '/expenses/debit-notes/new'
    | '/expenses/expenses/$documentId'
    | '/expenses/expenses/new'
    | '/expenses/payments/$paymentId'
    | '/expenses/purchase-orders/$documentId'
    | '/expenses/purchase-orders/new'
    | '/expenses/vendors/$contactId'
    | '/reports/management/$packId'
    | '/reports/management/new'
    | '/reports/parallel-run/$runId'
    | '/sales/credit-notes/$documentId'
    | '/sales/credit-notes/new'
    | '/sales/customers/$contactId'
    | '/sales/delivery-challans/$documentId'
    | '/sales/delivery-challans/new'
    | '/sales/invoices/$documentId'
    | '/sales/invoices/new'
    | '/sales/payments/$paymentId'
    | '/sales/quotes/$documentId'
    | '/sales/quotes/new'
    | '/sales/receive-payment/new'
    | '/sales/sales-orders/$documentId'
    | '/sales/sales-orders/new'
    | '/sales/sales-receipts/$documentId'
    | '/sales/sales-receipts/new'
    | '/sales/statements/new'
    | '/settings/import/$kind'
    | '/settings/migration/opening-balances'
    | '/settings/migration/transactions'
    | '/taxes/gst/eway-bills'
    | '/taxes/gst/gstr1'
    | '/taxes/gst/gstr3b'
    | '/taxes/gst/ims'
    | '/taxes/vat/rates'
    | '/taxes/vat/settings'
    | '/accounting/budgets'
    | '/accounting/chart-of-accounts'
    | '/accounting/fixed-assets'
    | '/accounting/journal-entries'
    | '/accounting/periods'
    | '/accounting/recurring'
    | '/banking/reconcile'
    | '/expenses/bills'
    | '/expenses/purchase-orders'
    | '/expenses/vendors'
    | '/reports/parallel-run'
    | '/sales/customers'
    | '/sales/delivery-challans'
    | '/sales/invoices'
    | '/sales/products-and-services'
    | '/sales/quotes'
    | '/sales/sales-orders'
    | '/settings/import'
    | '/settings/migration'
    | '/taxes/gst'
    | '/taxes/vat'
    | '/accounting/chart-of-accounts/$accountId/register'
    | '/accounting/periods/$fiscalYearId/close'
    | '/banking/reconcile/$reconciliationId/report'
    | '/settings/migration/history/$runId'
    | '/settings/migration/open-items/$side'
    | '/taxes/vat/returns/$key'
    | '/banking/reconcile/$reconciliationId'
    | '/settings/migration/history'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/dashboard'
    | '/demo'
    | '/login'
    | '/messages'
    | '/onboarding'
    | '/signup'
    | '/accounting/audit-log'
    | '/accounting/reclassify'
    | '/accounting/write-off-invoices'
    | '/ai-accountant/$id'
    | '/auth/callback'
    | '/banking/import'
    | '/banking/rules'
    | '/documents/approvals'
    | '/documents/inbox'
    | '/expenses/pay-bills'
    | '/help/shortcuts'
    | '/inventory/adjust'
    | '/practice/clients'
    | '/projects/$projectId'
    | '/reports/$reportKey'
    | '/reports/vat-detail'
    | '/reports/vat-exception'
    | '/reports/vat-summary'
    | '/sales/all'
    | '/settings/attachments'
    | '/settings/classes'
    | '/settings/company'
    | '/settings/currencies'
    | '/settings/export'
    | '/settings/locations'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/sent-emails'
    | '/settings/tags'
    | '/settings/users'
    | '/taxes/corporate-tax'
    | '/taxes/e-invoicing'
    | '/ai-accountant/'
    | '/banking/'
    | '/expenses/'
    | '/projects/'
    | '/reports/'
    | '/sales/'
    | '/accounting/budgets/$budgetId'
    | '/accounting/fixed-assets/$assetId'
    | '/accounting/journal-entries/$entryId'
    | '/accounting/journal-entries/new'
    | '/accounting/recurring/$templateId'
    | '/accounting/recurring/new'
    | '/banking/transfers/new'
    | '/expenses/bills/$documentId'
    | '/expenses/bills/new'
    | '/expenses/debit-notes/$documentId'
    | '/expenses/debit-notes/new'
    | '/expenses/expenses/$documentId'
    | '/expenses/expenses/new'
    | '/expenses/payments/$paymentId'
    | '/expenses/purchase-orders/$documentId'
    | '/expenses/purchase-orders/new'
    | '/expenses/vendors/$contactId'
    | '/reports/management/$packId'
    | '/reports/management/new'
    | '/reports/parallel-run/$runId'
    | '/sales/credit-notes/$documentId'
    | '/sales/credit-notes/new'
    | '/sales/customers/$contactId'
    | '/sales/delivery-challans/$documentId'
    | '/sales/delivery-challans/new'
    | '/sales/invoices/$documentId'
    | '/sales/invoices/new'
    | '/sales/payments/$paymentId'
    | '/sales/quotes/$documentId'
    | '/sales/quotes/new'
    | '/sales/receive-payment/new'
    | '/sales/sales-orders/$documentId'
    | '/sales/sales-orders/new'
    | '/sales/sales-receipts/$documentId'
    | '/sales/sales-receipts/new'
    | '/sales/statements/new'
    | '/settings/import/$kind'
    | '/settings/migration/opening-balances'
    | '/settings/migration/transactions'
    | '/taxes/gst/eway-bills'
    | '/taxes/gst/gstr1'
    | '/taxes/gst/gstr3b'
    | '/taxes/gst/ims'
    | '/taxes/vat/rates'
    | '/taxes/vat/settings'
    | '/accounting/budgets/'
    | '/accounting/chart-of-accounts/'
    | '/accounting/fixed-assets/'
    | '/accounting/journal-entries/'
    | '/accounting/periods/'
    | '/accounting/recurring/'
    | '/banking/reconcile/'
    | '/expenses/bills/'
    | '/expenses/purchase-orders/'
    | '/expenses/vendors/'
    | '/reports/parallel-run/'
    | '/sales/customers/'
    | '/sales/delivery-challans/'
    | '/sales/invoices/'
    | '/sales/products-and-services/'
    | '/sales/quotes/'
    | '/sales/sales-orders/'
    | '/settings/import/'
    | '/settings/migration/'
    | '/taxes/gst/'
    | '/taxes/vat/'
    | '/accounting/chart-of-accounts/$accountId/register'
    | '/accounting/periods/$fiscalYearId/close'
    | '/banking/reconcile/$reconciliationId/report'
    | '/settings/migration/history/$runId'
    | '/settings/migration/open-items/$side'
    | '/taxes/vat/returns/$key'
    | '/banking/reconcile/$reconciliationId/'
    | '/settings/migration/history/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  DashboardRoute: typeof DashboardRoute
  DemoRoute: typeof DemoRoute
  LoginRoute: typeof LoginRoute
  MessagesRoute: typeof MessagesRoute
  OnboardingRoute: typeof OnboardingRoute
  SignupRoute: typeof SignupRoute
  AccountingAuditLogRoute: typeof AccountingAuditLogRoute
  AccountingReclassifyRoute: typeof AccountingReclassifyRoute
  AccountingWriteOffInvoicesRoute: typeof AccountingWriteOffInvoicesRoute
  AiAccountantIdRoute: typeof AiAccountantIdRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  BankingImportRoute: typeof BankingImportRoute
  BankingRulesRoute: typeof BankingRulesRoute
  DocumentsApprovalsRoute: typeof DocumentsApprovalsRoute
  DocumentsInboxRoute: typeof DocumentsInboxRoute
  ExpensesPayBillsRoute: typeof ExpensesPayBillsRoute
  HelpShortcutsRoute: typeof HelpShortcutsRoute
  InventoryAdjustRoute: typeof InventoryAdjustRoute
  PracticeClientsRoute: typeof PracticeClientsRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ReportsReportKeyRoute: typeof ReportsReportKeyRoute
  ReportsVatDetailRoute: typeof ReportsVatDetailRoute
  ReportsVatExceptionRoute: typeof ReportsVatExceptionRoute
  ReportsVatSummaryRoute: typeof ReportsVatSummaryRoute
  SalesAllRoute: typeof SalesAllRoute
  SettingsAttachmentsRoute: typeof SettingsAttachmentsRoute
  SettingsClassesRoute: typeof SettingsClassesRoute
  SettingsCompanyRoute: typeof SettingsCompanyRoute
  SettingsCurrenciesRoute: typeof SettingsCurrenciesRoute
  SettingsExportRoute: typeof SettingsExportRoute
  SettingsLocationsRoute: typeof SettingsLocationsRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsSentEmailsRoute: typeof SettingsSentEmailsRoute
  SettingsTagsRoute: typeof SettingsTagsRoute
  SettingsUsersRoute: typeof SettingsUsersRoute
  TaxesCorporateTaxRoute: typeof TaxesCorporateTaxRoute
  TaxesEInvoicingRoute: typeof TaxesEInvoicingRoute
  AiAccountantIndexRoute: typeof AiAccountantIndexRoute
  BankingIndexRoute: typeof BankingIndexRoute
  ExpensesIndexRoute: typeof ExpensesIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  SalesIndexRoute: typeof SalesIndexRoute
  AccountingBudgetsBudgetIdRoute: typeof AccountingBudgetsBudgetIdRoute
  AccountingFixedAssetsAssetIdRoute: typeof AccountingFixedAssetsAssetIdRoute
  AccountingJournalEntriesEntryIdRoute: typeof AccountingJournalEntriesEntryIdRoute
  AccountingJournalEntriesNewRoute: typeof AccountingJournalEntriesNewRoute
  AccountingRecurringTemplateIdRoute: typeof AccountingRecurringTemplateIdRoute
  AccountingRecurringNewRoute: typeof AccountingRecurringNewRoute
  BankingTransfersNewRoute: typeof BankingTransfersNewRoute
  ExpensesBillsDocumentIdRoute: typeof ExpensesBillsDocumentIdRoute
  ExpensesBillsNewRoute: typeof ExpensesBillsNewRoute
  ExpensesDebitNotesDocumentIdRoute: typeof ExpensesDebitNotesDocumentIdRoute
  ExpensesDebitNotesNewRoute: typeof ExpensesDebitNotesNewRoute
  ExpensesExpensesDocumentIdRoute: typeof ExpensesExpensesDocumentIdRoute
  ExpensesExpensesNewRoute: typeof ExpensesExpensesNewRoute
  ExpensesPaymentsPaymentIdRoute: typeof ExpensesPaymentsPaymentIdRoute
  ExpensesPurchaseOrdersDocumentIdRoute: typeof ExpensesPurchaseOrdersDocumentIdRoute
  ExpensesPurchaseOrdersNewRoute: typeof ExpensesPurchaseOrdersNewRoute
  ExpensesVendorsContactIdRoute: typeof ExpensesVendorsContactIdRoute
  ReportsManagementPackIdRoute: typeof ReportsManagementPackIdRoute
  ReportsManagementNewRoute: typeof ReportsManagementNewRoute
  ReportsParallelRunRunIdRoute: typeof ReportsParallelRunRunIdRoute
  SalesCreditNotesDocumentIdRoute: typeof SalesCreditNotesDocumentIdRoute
  SalesCreditNotesNewRoute: typeof SalesCreditNotesNewRoute
  SalesCustomersContactIdRoute: typeof SalesCustomersContactIdRoute
  SalesDeliveryChallansDocumentIdRoute: typeof SalesDeliveryChallansDocumentIdRoute
  SalesDeliveryChallansNewRoute: typeof SalesDeliveryChallansNewRoute
  SalesInvoicesDocumentIdRoute: typeof SalesInvoicesDocumentIdRoute
  SalesInvoicesNewRoute: typeof SalesInvoicesNewRoute
  SalesPaymentsPaymentIdRoute: typeof SalesPaymentsPaymentIdRoute
  SalesQuotesDocumentIdRoute: typeof SalesQuotesDocumentIdRoute
  SalesQuotesNewRoute: typeof SalesQuotesNewRoute
  SalesReceivePaymentNewRoute: typeof SalesReceivePaymentNewRoute
  SalesSalesOrdersDocumentIdRoute: typeof SalesSalesOrdersDocumentIdRoute
  SalesSalesOrdersNewRoute: typeof SalesSalesOrdersNewRoute
  SalesSalesReceiptsDocumentIdRoute: typeof SalesSalesReceiptsDocumentIdRoute
  SalesSalesReceiptsNewRoute: typeof SalesSalesReceiptsNewRoute
  SalesStatementsNewRoute: typeof SalesStatementsNewRoute
  SettingsImportKindRoute: typeof SettingsImportKindRoute
  SettingsMigrationOpeningBalancesRoute: typeof SettingsMigrationOpeningBalancesRoute
  SettingsMigrationTransactionsRoute: typeof SettingsMigrationTransactionsRoute
  TaxesGstEwayBillsRoute: typeof TaxesGstEwayBillsRoute
  TaxesGstGstr1Route: typeof TaxesGstGstr1Route
  TaxesGstGstr3bRoute: typeof TaxesGstGstr3bRoute
  TaxesGstImsRoute: typeof TaxesGstImsRoute
  TaxesVatRatesRoute: typeof TaxesVatRatesRoute
  TaxesVatSettingsRoute: typeof TaxesVatSettingsRoute
  AccountingBudgetsIndexRoute: typeof AccountingBudgetsIndexRoute
  AccountingChartOfAccountsIndexRoute: typeof AccountingChartOfAccountsIndexRoute
  AccountingFixedAssetsIndexRoute: typeof AccountingFixedAssetsIndexRoute
  AccountingJournalEntriesIndexRoute: typeof AccountingJournalEntriesIndexRoute
  AccountingPeriodsIndexRoute: typeof AccountingPeriodsIndexRoute
  AccountingRecurringIndexRoute: typeof AccountingRecurringIndexRoute
  BankingReconcileIndexRoute: typeof BankingReconcileIndexRoute
  ExpensesBillsIndexRoute: typeof ExpensesBillsIndexRoute
  ExpensesPurchaseOrdersIndexRoute: typeof ExpensesPurchaseOrdersIndexRoute
  ExpensesVendorsIndexRoute: typeof ExpensesVendorsIndexRoute
  ReportsParallelRunIndexRoute: typeof ReportsParallelRunIndexRoute
  SalesCustomersIndexRoute: typeof SalesCustomersIndexRoute
  SalesDeliveryChallansIndexRoute: typeof SalesDeliveryChallansIndexRoute
  SalesInvoicesIndexRoute: typeof SalesInvoicesIndexRoute
  SalesProductsAndServicesIndexRoute: typeof SalesProductsAndServicesIndexRoute
  SalesQuotesIndexRoute: typeof SalesQuotesIndexRoute
  SalesSalesOrdersIndexRoute: typeof SalesSalesOrdersIndexRoute
  SettingsImportIndexRoute: typeof SettingsImportIndexRoute
  SettingsMigrationIndexRoute: typeof SettingsMigrationIndexRoute
  TaxesGstIndexRoute: typeof TaxesGstIndexRoute
  TaxesVatIndexRoute: typeof TaxesVatIndexRoute
  AccountingChartOfAccountsAccountIdRegisterRoute: typeof AccountingChartOfAccountsAccountIdRegisterRoute
  AccountingPeriodsFiscalYearIdCloseRoute: typeof AccountingPeriodsFiscalYearIdCloseRoute
  BankingReconcileReconciliationIdReportRoute: typeof BankingReconcileReconciliationIdReportRoute
  SettingsMigrationHistoryRunIdRoute: typeof SettingsMigrationHistoryRunIdRoute
  SettingsMigrationOpenItemsSideRoute: typeof SettingsMigrationOpenItemsSideRoute
  TaxesVatReturnsKeyRoute: typeof TaxesVatReturnsKeyRoute
  BankingReconcileReconciliationIdIndexRoute: typeof BankingReconcileReconciliationIdIndexRoute
  SettingsMigrationHistoryIndexRoute: typeof SettingsMigrationHistoryIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/messages': {
      id: '/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof MessagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/audit-log': {
      id: '/accounting/audit-log'
      path: '/accounting/audit-log'
      fullPath: '/accounting/audit-log'
      preLoaderRoute: typeof AccountingAuditLogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/reclassify': {
      id: '/accounting/reclassify'
      path: '/accounting/reclassify'
      fullPath: '/accounting/reclassify'
      preLoaderRoute: typeof AccountingReclassifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/write-off-invoices': {
      id: '/accounting/write-off-invoices'
      path: '/accounting/write-off-invoices'
      fullPath: '/accounting/write-off-invoices'
      preLoaderRoute: typeof AccountingWriteOffInvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-accountant/': {
      id: '/ai-accountant/'
      path: '/ai-accountant'
      fullPath: '/ai-accountant/'
      preLoaderRoute: typeof AiAccountantIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-accountant/$id': {
      id: '/ai-accountant/$id'
      path: '/ai-accountant/$id'
      fullPath: '/ai-accountant/$id'
      preLoaderRoute: typeof AiAccountantIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/banking/': {
      id: '/banking/'
      path: '/banking'
      fullPath: '/banking/'
      preLoaderRoute: typeof BankingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/banking/import': {
      id: '/banking/import'
      path: '/banking/import'
      fullPath: '/banking/import'
      preLoaderRoute: typeof BankingImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/banking/rules': {
      id: '/banking/rules'
      path: '/banking/rules'
      fullPath: '/banking/rules'
      preLoaderRoute: typeof BankingRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/approvals': {
      id: '/documents/approvals'
      path: '/documents/approvals'
      fullPath: '/documents/approvals'
      preLoaderRoute: typeof DocumentsApprovalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/inbox': {
      id: '/documents/inbox'
      path: '/documents/inbox'
      fullPath: '/documents/inbox'
      preLoaderRoute: typeof DocumentsInboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/': {
      id: '/expenses/'
      path: '/expenses'
      fullPath: '/expenses/'
      preLoaderRoute: typeof ExpensesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/pay-bills': {
      id: '/expenses/pay-bills'
      path: '/expenses/pay-bills'
      fullPath: '/expenses/pay-bills'
      preLoaderRoute: typeof ExpensesPayBillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/shortcuts': {
      id: '/help/shortcuts'
      path: '/help/shortcuts'
      fullPath: '/help/shortcuts'
      preLoaderRoute: typeof HelpShortcutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory/adjust': {
      id: '/inventory/adjust'
      path: '/inventory/adjust'
      fullPath: '/inventory/adjust'
      preLoaderRoute: typeof InventoryAdjustRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/practice/clients': {
      id: '/practice/clients'
      path: '/practice/clients'
      fullPath: '/practice/clients'
      preLoaderRoute: typeof PracticeClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/$reportKey': {
      id: '/reports/$reportKey'
      path: '/reports/$reportKey'
      fullPath: '/reports/$reportKey'
      preLoaderRoute: typeof ReportsReportKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/vat-detail': {
      id: '/reports/vat-detail'
      path: '/reports/vat-detail'
      fullPath: '/reports/vat-detail'
      preLoaderRoute: typeof ReportsVatDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/vat-exception': {
      id: '/reports/vat-exception'
      path: '/reports/vat-exception'
      fullPath: '/reports/vat-exception'
      preLoaderRoute: typeof ReportsVatExceptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/vat-summary': {
      id: '/reports/vat-summary'
      path: '/reports/vat-summary'
      fullPath: '/reports/vat-summary'
      preLoaderRoute: typeof ReportsVatSummaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/': {
      id: '/sales/'
      path: '/sales'
      fullPath: '/sales/'
      preLoaderRoute: typeof SalesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/all': {
      id: '/sales/all'
      path: '/sales/all'
      fullPath: '/sales/all'
      preLoaderRoute: typeof SalesAllRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/attachments': {
      id: '/settings/attachments'
      path: '/settings/attachments'
      fullPath: '/settings/attachments'
      preLoaderRoute: typeof SettingsAttachmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/classes': {
      id: '/settings/classes'
      path: '/settings/classes'
      fullPath: '/settings/classes'
      preLoaderRoute: typeof SettingsClassesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/company': {
      id: '/settings/company'
      path: '/settings/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof SettingsCompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/currencies': {
      id: '/settings/currencies'
      path: '/settings/currencies'
      fullPath: '/settings/currencies'
      preLoaderRoute: typeof SettingsCurrenciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/export': {
      id: '/settings/export'
      path: '/settings/export'
      fullPath: '/settings/export'
      preLoaderRoute: typeof SettingsExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/locations': {
      id: '/settings/locations'
      path: '/settings/locations'
      fullPath: '/settings/locations'
      preLoaderRoute: typeof SettingsLocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/sent-emails': {
      id: '/settings/sent-emails'
      path: '/settings/sent-emails'
      fullPath: '/settings/sent-emails'
      preLoaderRoute: typeof SettingsSentEmailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/tags': {
      id: '/settings/tags'
      path: '/settings/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof SettingsTagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/users': {
      id: '/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxes/corporate-tax': {
      id: '/taxes/corporate-tax'
      path: '/taxes/corporate-tax'
      fullPath: '/taxes/corporate-tax'
      preLoaderRoute: typeof TaxesCorporateTaxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxes/e-invoicing': {
      id: '/taxes/e-invoicing'
      path: '/taxes/e-invoicing'
      fullPath: '/taxes/e-invoicing'
      preLoaderRoute: typeof TaxesEInvoicingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/budgets/': {
      id: '/accounting/budgets/'
      path: '/accounting/budgets'
      fullPath: '/accounting/budgets/'
      preLoaderRoute: typeof AccountingBudgetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/budgets/$budgetId': {
      id: '/accounting/budgets/$budgetId'
      path: '/accounting/budgets/$budgetId'
      fullPath: '/accounting/budgets/$budgetId'
      preLoaderRoute: typeof AccountingBudgetsBudgetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/chart-of-accounts/': {
      id: '/accounting/chart-of-accounts/'
      path: '/accounting/chart-of-accounts'
      fullPath: '/accounting/chart-of-accounts/'
      preLoaderRoute: typeof AccountingChartOfAccountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/fixed-assets/': {
      id: '/accounting/fixed-assets/'
      path: '/accounting/fixed-assets'
      fullPath: '/accounting/fixed-assets/'
      preLoaderRoute: typeof AccountingFixedAssetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/fixed-assets/$assetId': {
      id: '/accounting/fixed-assets/$assetId'
      path: '/accounting/fixed-assets/$assetId'
      fullPath: '/accounting/fixed-assets/$assetId'
      preLoaderRoute: typeof AccountingFixedAssetsAssetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/journal-entries/': {
      id: '/accounting/journal-entries/'
      path: '/accounting/journal-entries'
      fullPath: '/accounting/journal-entries/'
      preLoaderRoute: typeof AccountingJournalEntriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/journal-entries/$entryId': {
      id: '/accounting/journal-entries/$entryId'
      path: '/accounting/journal-entries/$entryId'
      fullPath: '/accounting/journal-entries/$entryId'
      preLoaderRoute: typeof AccountingJournalEntriesEntryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/journal-entries/new': {
      id: '/accounting/journal-entries/new'
      path: '/accounting/journal-entries/new'
      fullPath: '/accounting/journal-entries/new'
      preLoaderRoute: typeof AccountingJournalEntriesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/periods/': {
      id: '/accounting/periods/'
      path: '/accounting/periods'
      fullPath: '/accounting/periods/'
      preLoaderRoute: typeof AccountingPeriodsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/recurring/': {
      id: '/accounting/recurring/'
      path: '/accounting/recurring'
      fullPath: '/accounting/recurring/'
      preLoaderRoute: typeof AccountingRecurringIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/recurring/$templateId': {
      id: '/accounting/recurring/$templateId'
      path: '/accounting/recurring/$templateId'
      fullPath: '/accounting/recurring/$templateId'
      preLoaderRoute: typeof AccountingRecurringTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/recurring/new': {
      id: '/accounting/recurring/new'
      path: '/accounting/recurring/new'
      fullPath: '/accounting/recurring/new'
      preLoaderRoute: typeof AccountingRecurringNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/banking/reconcile/': {
      id: '/banking/reconcile/'
      path: '/banking/reconcile'
      fullPath: '/banking/reconcile/'
      preLoaderRoute: typeof BankingReconcileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/banking/transfers/new': {
      id: '/banking/transfers/new'
      path: '/banking/transfers/new'
      fullPath: '/banking/transfers/new'
      preLoaderRoute: typeof BankingTransfersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/bills/': {
      id: '/expenses/bills/'
      path: '/expenses/bills'
      fullPath: '/expenses/bills/'
      preLoaderRoute: typeof ExpensesBillsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/bills/$documentId': {
      id: '/expenses/bills/$documentId'
      path: '/expenses/bills/$documentId'
      fullPath: '/expenses/bills/$documentId'
      preLoaderRoute: typeof ExpensesBillsDocumentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/bills/new': {
      id: '/expenses/bills/new'
      path: '/expenses/bills/new'
      fullPath: '/expenses/bills/new'
      preLoaderRoute: typeof ExpensesBillsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/debit-notes/$documentId': {
      id: '/expenses/debit-notes/$documentId'
      path: '/expenses/debit-notes/$documentId'
      fullPath: '/expenses/debit-notes/$documentId'
      preLoaderRoute: typeof ExpensesDebitNotesDocumentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/debit-notes/new': {
      id: '/expenses/debit-notes/new'
      path: '/expenses/debit-notes/new'
      fullPath: '/expenses/debit-notes/new'
      preLoaderRoute: typeof ExpensesDebitNotesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/expenses/$documentId': {
      id: '/expenses/expenses/$documentId'
      path: '/expenses/expenses/$documentId'
      fullPath: '/expenses/expenses/$documentId'
      preLoaderRoute: typeof ExpensesExpensesDocumentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/expenses/new': {
      id: '/expenses/expenses/new'
      path: '/expenses/expenses/new'
      fullPath: '/expenses/expenses/new'
      preLoaderRoute: typeof ExpensesExpensesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/payments/$paymentId': {
      id: '/expenses/payments/$paymentId'
      path: '/expenses/payments/$paymentId'
      fullPath: '/expenses/payments/$paymentId'
      preLoaderRoute: typeof ExpensesPaymentsPaymentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/purchase-orders/': {
      id: '/expenses/purchase-orders/'
      path: '/expenses/purchase-orders'
      fullPath: '/expenses/purchase-orders/'
      preLoaderRoute: typeof ExpensesPurchaseOrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/purchase-orders/$documentId': {
      id: '/expenses/purchase-orders/$documentId'
      path: '/expenses/purchase-orders/$documentId'
      fullPath: '/expenses/purchase-orders/$documentId'
      preLoaderRoute: typeof ExpensesPurchaseOrdersDocumentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/purchase-orders/new': {
      id: '/expenses/purchase-orders/new'
      path: '/expenses/purchase-orders/new'
      fullPath: '/expenses/purchase-orders/new'
      preLoaderRoute: typeof ExpensesPurchaseOrdersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/vendors/': {
      id: '/expenses/vendors/'
      path: '/expenses/vendors'
      fullPath: '/expenses/vendors/'
      preLoaderRoute: typeof ExpensesVendorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses/vendors/$contactId': {
      id: '/expenses/vendors/$contactId'
      path: '/expenses/vendors/$contactId'
      fullPath: '/expenses/vendors/$contactId'
      preLoaderRoute: typeof ExpensesVendorsContactIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/management/$packId': {
      id: '/reports/management/$packId'
      path: '/reports/management/$packId'
      fullPath: '/reports/management/$packId'
      preLoaderRoute: typeof ReportsManagementPackIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/management/new': {
      id: '/reports/management/new'
      path: '/reports/management/new'
      fullPath: '/reports/management/new'
      preLoaderRoute: typeof ReportsManagementNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/parallel-run/': {
      id: '/reports/parallel-run/'
      path: '/reports/parallel-run'
      fullPath: '/reports/parallel-run/'
      preLoaderRoute: typeof ReportsParallelRunIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/parallel-run/$runId': {
      id: '/reports/parallel-run/$runId'
      path: '/reports/parallel-run/$runId'
      fullPath: '/reports/parallel-run/$runId'
      preLoaderRoute: typeof ReportsParallelRunRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/credit-notes/$documentId': {
      id: '/sales/credit-notes/$documentId'
      path: '/sales/credit-notes/$documentId'
      fullPath: '/sales/credit-notes/$documentId'
      preLoaderRoute: typeof SalesCreditNotesDocumentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/credit-notes/new': {
      id: '/sales/credit-notes/new'
      path: '/sales/credit-notes/new'
      fullPath: '/sales/credit-notes/new'
      preLoaderRoute: typeof SalesCreditNotesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/customers/': {
      id: '/sales/customers/'
      path: '/sales/customers'
      fullPath: '/sales/customers/'
      preLoaderRoute: typeof SalesCustomersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/customers/$contactId': {
      id: '/sales/customers/$contactId'
      path: '/sales/customers/$contactId'
      fullPath: '/sales/customers/$contactId'
      preLoaderRoute: typeof SalesCustomersContactIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/delivery-challans/': {
      id: '/sales/delivery-challans/'
      path: '/sales/delivery-challans'
      fullPath: '/sales/delivery-challans/'
      preLoaderRoute: typeof SalesDeliveryChallansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/delivery-challans/$documentId': {
      id: '/sales/delivery-challans/$documentId'
      path: '/sales/delivery-challans/$documentId'
      fullPath: '/sales/delivery-challans/$documentId'
      preLoaderRoute: typeof SalesDeliveryChallansDocumentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/delivery-challans/new': {
      id: '/sales/delivery-challans/new'
      path: '/sales/delivery-challans/new'
      fullPath: '/sales/delivery-challans/new'
      preLoaderRoute: typeof SalesDeliveryChallansNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/invoices/': {
      id: '/sales/invoices/'
      path: '/sales/invoices'
      fullPath: '/sales/invoices/'
      preLoaderRoute: typeof SalesInvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/invoices/$documentId': {
      id: '/sales/invoices/$documentId'
      path: '/sales/invoices/$documentId'
      fullPath: '/sales/invoices/$documentId'
      preLoaderRoute: typeof SalesInvoicesDocumentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/invoices/new': {
      id: '/sales/invoices/new'
      path: '/sales/invoices/new'
      fullPath: '/sales/invoices/new'
      preLoaderRoute: typeof SalesInvoicesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/payments/$paymentId': {
      id: '/sales/payments/$paymentId'
      path: '/sales/payments/$paymentId'
      fullPath: '/sales/payments/$paymentId'
      preLoaderRoute: typeof SalesPaymentsPaymentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/products-and-services/': {
      id: '/sales/products-and-services/'
      path: '/sales/products-and-services'
      fullPath: '/sales/products-and-services/'
      preLoaderRoute: typeof SalesProductsAndServicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/quotes/': {
      id: '/sales/quotes/'
      path: '/sales/quotes'
      fullPath: '/sales/quotes/'
      preLoaderRoute: typeof SalesQuotesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/quotes/$documentId': {
      id: '/sales/quotes/$documentId'
      path: '/sales/quotes/$documentId'
      fullPath: '/sales/quotes/$documentId'
      preLoaderRoute: typeof SalesQuotesDocumentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/quotes/new': {
      id: '/sales/quotes/new'
      path: '/sales/quotes/new'
      fullPath: '/sales/quotes/new'
      preLoaderRoute: typeof SalesQuotesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/receive-payment/new': {
      id: '/sales/receive-payment/new'
      path: '/sales/receive-payment/new'
      fullPath: '/sales/receive-payment/new'
      preLoaderRoute: typeof SalesReceivePaymentNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/sales-orders/': {
      id: '/sales/sales-orders/'
      path: '/sales/sales-orders'
      fullPath: '/sales/sales-orders/'
      preLoaderRoute: typeof SalesSalesOrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/sales-orders/$documentId': {
      id: '/sales/sales-orders/$documentId'
      path: '/sales/sales-orders/$documentId'
      fullPath: '/sales/sales-orders/$documentId'
      preLoaderRoute: typeof SalesSalesOrdersDocumentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/sales-orders/new': {
      id: '/sales/sales-orders/new'
      path: '/sales/sales-orders/new'
      fullPath: '/sales/sales-orders/new'
      preLoaderRoute: typeof SalesSalesOrdersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/sales-receipts/$documentId': {
      id: '/sales/sales-receipts/$documentId'
      path: '/sales/sales-receipts/$documentId'
      fullPath: '/sales/sales-receipts/$documentId'
      preLoaderRoute: typeof SalesSalesReceiptsDocumentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/sales-receipts/new': {
      id: '/sales/sales-receipts/new'
      path: '/sales/sales-receipts/new'
      fullPath: '/sales/sales-receipts/new'
      preLoaderRoute: typeof SalesSalesReceiptsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales/statements/new': {
      id: '/sales/statements/new'
      path: '/sales/statements/new'
      fullPath: '/sales/statements/new'
      preLoaderRoute: typeof SalesStatementsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/import/': {
      id: '/settings/import/'
      path: '/settings/import'
      fullPath: '/settings/import/'
      preLoaderRoute: typeof SettingsImportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/import/$kind': {
      id: '/settings/import/$kind'
      path: '/settings/import/$kind'
      fullPath: '/settings/import/$kind'
      preLoaderRoute: typeof SettingsImportKindRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/migration/': {
      id: '/settings/migration/'
      path: '/settings/migration'
      fullPath: '/settings/migration/'
      preLoaderRoute: typeof SettingsMigrationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/migration/opening-balances': {
      id: '/settings/migration/opening-balances'
      path: '/settings/migration/opening-balances'
      fullPath: '/settings/migration/opening-balances'
      preLoaderRoute: typeof SettingsMigrationOpeningBalancesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/migration/transactions': {
      id: '/settings/migration/transactions'
      path: '/settings/migration/transactions'
      fullPath: '/settings/migration/transactions'
      preLoaderRoute: typeof SettingsMigrationTransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxes/gst/': {
      id: '/taxes/gst/'
      path: '/taxes/gst'
      fullPath: '/taxes/gst/'
      preLoaderRoute: typeof TaxesGstIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxes/gst/eway-bills': {
      id: '/taxes/gst/eway-bills'
      path: '/taxes/gst/eway-bills'
      fullPath: '/taxes/gst/eway-bills'
      preLoaderRoute: typeof TaxesGstEwayBillsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxes/gst/gstr1': {
      id: '/taxes/gst/gstr1'
      path: '/taxes/gst/gstr1'
      fullPath: '/taxes/gst/gstr1'
      preLoaderRoute: typeof TaxesGstGstr1RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxes/gst/gstr3b': {
      id: '/taxes/gst/gstr3b'
      path: '/taxes/gst/gstr3b'
      fullPath: '/taxes/gst/gstr3b'
      preLoaderRoute: typeof TaxesGstGstr3bRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxes/gst/ims': {
      id: '/taxes/gst/ims'
      path: '/taxes/gst/ims'
      fullPath: '/taxes/gst/ims'
      preLoaderRoute: typeof TaxesGstImsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxes/vat/': {
      id: '/taxes/vat/'
      path: '/taxes/vat'
      fullPath: '/taxes/vat/'
      preLoaderRoute: typeof TaxesVatIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxes/vat/rates': {
      id: '/taxes/vat/rates'
      path: '/taxes/vat/rates'
      fullPath: '/taxes/vat/rates'
      preLoaderRoute: typeof TaxesVatRatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxes/vat/settings': {
      id: '/taxes/vat/settings'
      path: '/taxes/vat/settings'
      fullPath: '/taxes/vat/settings'
      preLoaderRoute: typeof TaxesVatSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/chart-of-accounts/$accountId/register': {
      id: '/accounting/chart-of-accounts/$accountId/register'
      path: '/accounting/chart-of-accounts/$accountId/register'
      fullPath: '/accounting/chart-of-accounts/$accountId/register'
      preLoaderRoute: typeof AccountingChartOfAccountsAccountIdRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting/periods/$fiscalYearId/close': {
      id: '/accounting/periods/$fiscalYearId/close'
      path: '/accounting/periods/$fiscalYearId/close'
      fullPath: '/accounting/periods/$fiscalYearId/close'
      preLoaderRoute: typeof AccountingPeriodsFiscalYearIdCloseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/banking/reconcile/$reconciliationId/': {
      id: '/banking/reconcile/$reconciliationId/'
      path: '/banking/reconcile/$reconciliationId'
      fullPath: '/banking/reconcile/$reconciliationId/'
      preLoaderRoute: typeof BankingReconcileReconciliationIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/banking/reconcile/$reconciliationId/report': {
      id: '/banking/reconcile/$reconciliationId/report'
      path: '/banking/reconcile/$reconciliationId/report'
      fullPath: '/banking/reconcile/$reconciliationId/report'
      preLoaderRoute: typeof BankingReconcileReconciliationIdReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/migration/history/': {
      id: '/settings/migration/history/'
      path: '/settings/migration/history'
      fullPath: '/settings/migration/history/'
      preLoaderRoute: typeof SettingsMigrationHistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/migration/history/$runId': {
      id: '/settings/migration/history/$runId'
      path: '/settings/migration/history/$runId'
      fullPath: '/settings/migration/history/$runId'
      preLoaderRoute: typeof SettingsMigrationHistoryRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/migration/open-items/$side': {
      id: '/settings/migration/open-items/$side'
      path: '/settings/migration/open-items/$side'
      fullPath: '/settings/migration/open-items/$side'
      preLoaderRoute: typeof SettingsMigrationOpenItemsSideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/taxes/vat/returns/$key': {
      id: '/taxes/vat/returns/$key'
      path: '/taxes/vat/returns/$key'
      fullPath: '/taxes/vat/returns/$key'
      preLoaderRoute: typeof TaxesVatReturnsKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  DashboardRoute: DashboardRoute,
  DemoRoute: DemoRoute,
  LoginRoute: LoginRoute,
  MessagesRoute: MessagesRoute,
  OnboardingRoute: OnboardingRoute,
  SignupRoute: SignupRoute,
  AccountingAuditLogRoute: AccountingAuditLogRoute,
  AccountingReclassifyRoute: AccountingReclassifyRoute,
  AccountingWriteOffInvoicesRoute: AccountingWriteOffInvoicesRoute,
  AiAccountantIdRoute: AiAccountantIdRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  BankingImportRoute: BankingImportRoute,
  BankingRulesRoute: BankingRulesRoute,
  DocumentsApprovalsRoute: DocumentsApprovalsRoute,
  DocumentsInboxRoute: DocumentsInboxRoute,
  ExpensesPayBillsRoute: ExpensesPayBillsRoute,
  HelpShortcutsRoute: HelpShortcutsRoute,
  InventoryAdjustRoute: InventoryAdjustRoute,
  PracticeClientsRoute: PracticeClientsRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ReportsReportKeyRoute: ReportsReportKeyRoute,
  ReportsVatDetailRoute: ReportsVatDetailRoute,
  ReportsVatExceptionRoute: ReportsVatExceptionRoute,
  ReportsVatSummaryRoute: ReportsVatSummaryRoute,
  SalesAllRoute: SalesAllRoute,
  SettingsAttachmentsRoute: SettingsAttachmentsRoute,
  SettingsClassesRoute: SettingsClassesRoute,
  SettingsCompanyRoute: SettingsCompanyRoute,
  SettingsCurrenciesRoute: SettingsCurrenciesRoute,
  SettingsExportRoute: SettingsExportRoute,
  SettingsLocationsRoute: SettingsLocationsRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsSentEmailsRoute: SettingsSentEmailsRoute,
  SettingsTagsRoute: SettingsTagsRoute,
  SettingsUsersRoute: SettingsUsersRoute,
  TaxesCorporateTaxRoute: TaxesCorporateTaxRoute,
  TaxesEInvoicingRoute: TaxesEInvoicingRoute,
  AiAccountantIndexRoute: AiAccountantIndexRoute,
  BankingIndexRoute: BankingIndexRoute,
  ExpensesIndexRoute: ExpensesIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  SalesIndexRoute: SalesIndexRoute,
  AccountingBudgetsBudgetIdRoute: AccountingBudgetsBudgetIdRoute,
  AccountingFixedAssetsAssetIdRoute: AccountingFixedAssetsAssetIdRoute,
  AccountingJournalEntriesEntryIdRoute: AccountingJournalEntriesEntryIdRoute,
  AccountingJournalEntriesNewRoute: AccountingJournalEntriesNewRoute,
  AccountingRecurringTemplateIdRoute: AccountingRecurringTemplateIdRoute,
  AccountingRecurringNewRoute: AccountingRecurringNewRoute,
  BankingTransfersNewRoute: BankingTransfersNewRoute,
  ExpensesBillsDocumentIdRoute: ExpensesBillsDocumentIdRoute,
  ExpensesBillsNewRoute: ExpensesBillsNewRoute,
  ExpensesDebitNotesDocumentIdRoute: ExpensesDebitNotesDocumentIdRoute,
  ExpensesDebitNotesNewRoute: ExpensesDebitNotesNewRoute,
  ExpensesExpensesDocumentIdRoute: ExpensesExpensesDocumentIdRoute,
  ExpensesExpensesNewRoute: ExpensesExpensesNewRoute,
  ExpensesPaymentsPaymentIdRoute: ExpensesPaymentsPaymentIdRoute,
  ExpensesPurchaseOrdersDocumentIdRoute: ExpensesPurchaseOrdersDocumentIdRoute,
  ExpensesPurchaseOrdersNewRoute: ExpensesPurchaseOrdersNewRoute,
  ExpensesVendorsContactIdRoute: ExpensesVendorsContactIdRoute,
  ReportsManagementPackIdRoute: ReportsManagementPackIdRoute,
  ReportsManagementNewRoute: ReportsManagementNewRoute,
  ReportsParallelRunRunIdRoute: ReportsParallelRunRunIdRoute,
  SalesCreditNotesDocumentIdRoute: SalesCreditNotesDocumentIdRoute,
  SalesCreditNotesNewRoute: SalesCreditNotesNewRoute,
  SalesCustomersContactIdRoute: SalesCustomersContactIdRoute,
  SalesDeliveryChallansDocumentIdRoute: SalesDeliveryChallansDocumentIdRoute,
  SalesDeliveryChallansNewRoute: SalesDeliveryChallansNewRoute,
  SalesInvoicesDocumentIdRoute: SalesInvoicesDocumentIdRoute,
  SalesInvoicesNewRoute: SalesInvoicesNewRoute,
  SalesPaymentsPaymentIdRoute: SalesPaymentsPaymentIdRoute,
  SalesQuotesDocumentIdRoute: SalesQuotesDocumentIdRoute,
  SalesQuotesNewRoute: SalesQuotesNewRoute,
  SalesReceivePaymentNewRoute: SalesReceivePaymentNewRoute,
  SalesSalesOrdersDocumentIdRoute: SalesSalesOrdersDocumentIdRoute,
  SalesSalesOrdersNewRoute: SalesSalesOrdersNewRoute,
  SalesSalesReceiptsDocumentIdRoute: SalesSalesReceiptsDocumentIdRoute,
  SalesSalesReceiptsNewRoute: SalesSalesReceiptsNewRoute,
  SalesStatementsNewRoute: SalesStatementsNewRoute,
  SettingsImportKindRoute: SettingsImportKindRoute,
  SettingsMigrationOpeningBalancesRoute: SettingsMigrationOpeningBalancesRoute,
  SettingsMigrationTransactionsRoute: SettingsMigrationTransactionsRoute,
  TaxesGstEwayBillsRoute: TaxesGstEwayBillsRoute,
  TaxesGstGstr1Route: TaxesGstGstr1Route,
  TaxesGstGstr3bRoute: TaxesGstGstr3bRoute,
  TaxesGstImsRoute: TaxesGstImsRoute,
  TaxesVatRatesRoute: TaxesVatRatesRoute,
  TaxesVatSettingsRoute: TaxesVatSettingsRoute,
  AccountingBudgetsIndexRoute: AccountingBudgetsIndexRoute,
  AccountingChartOfAccountsIndexRoute: AccountingChartOfAccountsIndexRoute,
  AccountingFixedAssetsIndexRoute: AccountingFixedAssetsIndexRoute,
  AccountingJournalEntriesIndexRoute: AccountingJournalEntriesIndexRoute,
  AccountingPeriodsIndexRoute: AccountingPeriodsIndexRoute,
  AccountingRecurringIndexRoute: AccountingRecurringIndexRoute,
  BankingReconcileIndexRoute: BankingReconcileIndexRoute,
  ExpensesBillsIndexRoute: ExpensesBillsIndexRoute,
  ExpensesPurchaseOrdersIndexRoute: ExpensesPurchaseOrdersIndexRoute,
  ExpensesVendorsIndexRoute: ExpensesVendorsIndexRoute,
  ReportsParallelRunIndexRoute: ReportsParallelRunIndexRoute,
  SalesCustomersIndexRoute: SalesCustomersIndexRoute,
  SalesDeliveryChallansIndexRoute: SalesDeliveryChallansIndexRoute,
  SalesInvoicesIndexRoute: SalesInvoicesIndexRoute,
  SalesProductsAndServicesIndexRoute: SalesProductsAndServicesIndexRoute,
  SalesQuotesIndexRoute: SalesQuotesIndexRoute,
  SalesSalesOrdersIndexRoute: SalesSalesOrdersIndexRoute,
  SettingsImportIndexRoute: SettingsImportIndexRoute,
  SettingsMigrationIndexRoute: SettingsMigrationIndexRoute,
  TaxesGstIndexRoute: TaxesGstIndexRoute,
  TaxesVatIndexRoute: TaxesVatIndexRoute,
  AccountingChartOfAccountsAccountIdRegisterRoute:
    AccountingChartOfAccountsAccountIdRegisterRoute,
  AccountingPeriodsFiscalYearIdCloseRoute:
    AccountingPeriodsFiscalYearIdCloseRoute,
  BankingReconcileReconciliationIdReportRoute:
    BankingReconcileReconciliationIdReportRoute,
  SettingsMigrationHistoryRunIdRoute: SettingsMigrationHistoryRunIdRoute,
  SettingsMigrationOpenItemsSideRoute: SettingsMigrationOpenItemsSideRoute,
  TaxesVatReturnsKeyRoute: TaxesVatReturnsKeyRoute,
  BankingReconcileReconciliationIdIndexRoute:
    BankingReconcileReconciliationIdIndexRoute,
  SettingsMigrationHistoryIndexRoute: SettingsMigrationHistoryIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
